(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-breadcrumbs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function naarEinde(root) {
      (root || document).querySelectorAll('[data-sora-kp-lijst]').forEach(function (lijst) {
        if (lijst.scrollWidth > lijst.clientWidth) {
          lijst.scrollLeft = lijst.scrollWidth;
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        naarEinde();
      });
    } else {
      naarEinde();
    }

    document.addEventListener('shopify:section:load', function (event) {
      naarEinde(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sora-winkelwagenlade')) return;

    const LEES_OPTIES = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-totaal', 'hidden', 'aria-pressed', 'class', 'open'] };
    const TRUCK =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2.5 6.5h11v9h-11z"/><path d="M13.5 9.5h4l3 3v3h-7z"/><circle cx="6.5" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg>';

    const PLEK_GELD = new RegExp('[{]' + '[{]\\s*(\\w+)\\s*[}][}]');
    const bedrag = (t) => {
      const n = parseFloat(String(t == null ? '' : t).replace(/\s/g, '').replace(',', '.'));
      return Number.isFinite(n) ? Math.max(0, Math.round(n * 100)) : 0;
    };

    const esc = (t) =>
      String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

    /* Tekst uit de editor met plaatshouders: de tekst wordt veilig gemaakt, de waarden zijn HTML van dit script */
    const sjabloon = (tekst, waarden) => {
      let uit = esc(tekst);
      Object.keys(waarden).forEach((k) => {
        uit = uit.split('{' + k + '}').join(waarden[k]);
      });
      return uit;
    };

    /* Shopify money_format (shop.money_format), bijvoorbeeld euro met komma */
    const geld = (cent, formaat) => {
      const f = formaat || '€' + '{' + '{amount_with_comma_separator}' + '}';
      const getal = (n, dec, duizend, komma) => {
        const vast = (Math.round(n) / 100).toFixed(dec);
        const [heel, frac] = vast.split('.');
        const met = heel.replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
        return frac ? met + komma + frac : met;
      };
      const vormen = {
        amount: () => getal(cent, 2, ',', '.'),
        amount_no_decimals: () => getal(cent, 0, ',', '.'),
        amount_with_comma_separator: () => getal(cent, 2, '.', ','),
        amount_no_decimals_with_comma_separator: () => getal(cent, 0, '.', ','),
        amount_with_apostrophe_separator: () => getal(cent, 2, "'", '.'),
        amount_with_space_separator: () => getal(cent, 2, ' ', ','),
        amount_no_decimals_with_space_separator: () => getal(cent, 0, ' ', ','),
      };
      const html = f.replace(PLEK_GELD, (m, naam) => (vormen[naam] || vormen.amount)());
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.textContent;
    };

    let events = null;
    const laadEvents = async () => {
      if (events !== null) return events;
      try {
        events = await import('@shopify/events');
      } catch (fout) {
        events = false;
      }
      return events;
    };

    const tijdNaarSec = (t) => {
      const m = /^(\d{1,2})[:.](\d{2})$/.exec(String(t || '').trim());
      if (!m) return null;
      const u = Number(m[1]);
      const mi = Number(m[2]);
      if (u > 23 || mi > 59) return null;
      return u * 3600 + mi * 60;
    };

    const WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    /* Volgende verzendmoment in de tijdzone van de winkel. Geeft { vandaag, seconden } of { vandaag: false, dag } of null. */
    const verzendMoment = (cfg, nu) => {
      let delen;
      try {
        delen = new Intl.DateTimeFormat('en-GB', {
          timeZone: cfg.zone || 'Europe/Amsterdam',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23',
          weekday: 'short',
        }).formatToParts(nu);
      } catch (fout) {
        return null;
      }
      const p = {};
      delen.forEach((d) => {
        p[d.type] = d.value;
      });
      const j = Number(p.year);
      const mnd = Number(p.month);
      const dag = Number(p.day);
      const wd = WEEK.indexOf(p.weekday);
      if (wd < 0) return null;
      const nuSec = (Number(p.hour) % 24) * 3600 + Number(p.minute) * 60 + Number(p.second);
      const vrij = new Set((cfg.vrij || []).map((d) => String(d).trim()));
      const datum = (plus) => new Date(Date.UTC(j, mnd - 1, dag + plus));
      const iso = (plus) => datum(plus).toISOString().slice(0, 10);

      const grens = tijdNaarSec(cfg.dagen[wd]);
      if (grens !== null && !vrij.has(iso(0)) && nuSec < grens) return { vandaag: true, seconden: grens - nuSec };

      for (let i = 1; i <= 60; i += 1) {
        const w = (wd + i) % 7;
        if (tijdNaarSec(cfg.dagen[w]) === null || vrij.has(iso(i))) continue;
        let naam;
        if (i === 1) naam = cfg.morgen;
        else if (i < 7 && cfg.dagnamen && cfg.dagnamen[w]) naam = cfg.dagnamen[w];
        else {
          try {
            naam = new Intl.DateTimeFormat(cfg.taal || 'nl', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }).format(datum(i));
          } catch (fout) {
            naam = iso(i);
          }
        }
        return { vandaag: false, dag: naam };
      }
      return null;
    };

    class SoraWinkelwagenlade extends HTMLElement {
      connectedCallback() {
        if (this.gestart) return;
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
          return;
        }
        try {
          this.config = JSON.parse(this.querySelector('[data-sora-cd-config]').textContent);
        } catch (fout) {
          return;
        }
        this.lade = document.getElementById('cart-drawer');
        this.dialog = this.lade && this.lade.querySelector('dialog');
        this.comp = this.lade && this.lade.querySelector('cart-drawer-component');
        if (!this.lade || !this.dialog || !this.comp) return;
        this.gestart = true;
        this.config.tijd.taal = this.config.taal;

        this.comp.setAttribute('data-sora-cd', '');
        this.autoOrigineel = this.comp.hasAttribute('auto-open');
        if (this.config.autoOpenen) this.comp.setAttribute('auto-open', '');
        else this.comp.removeAttribute('auto-open');

        /* Wijzigingen in de aanbevelingen, de pop-up of de zwevende knop zijn niet van Horizon: die negeren */
        const eigen = (n) => {
          const el = n && (n.nodeType === 1 ? n : n.parentElement);
          return Boolean(el && el.closest('.sora-cu, .sora-cu-popup, .sora-cd-zweef'));
        };
        this.obs = new MutationObserver((lijst) => {
          if (lijst.every((m) => eigen(m.target))) return;
          this.bijwerken();
        });
        this.opKlik = (e) => this.klik(e);
        this.opWijzig = (e) => this.wijzig(e);
        this.opOpen = () => this.bijwerken();
        this.opSelect = (e) => {
          if (e.detail && e.detail.sectionId === this.config.sectie && typeof this.lade.open === 'function') this.lade.open();
        };
        document.addEventListener('click', this.opKlik);
        document.addEventListener('change', this.opWijzig);
        this.lade.addEventListener('theme-drawer:open', this.opOpen);
        document.addEventListener('shopify:section:select', this.opSelect);

        this.maakZweef();
        this.bijwerken();

        const t = this.config.tijd;
        const seconden = String(t.uren).includes('{s}') || String(t.minuten).includes('{s}');
        this.timer = setInterval(() => {
          if (this.lade.hasAttribute('open')) this.bijwerken();
        }, seconden ? 1000 : 15000);
      }

      disconnectedCallback() {
        if (!this.gestart) return;
        this.gestart = false;
        clearInterval(this.timer);
        if (this.obs) this.obs.disconnect();
        if (this.zicht) this.zicht.disconnect();
        if (this.zweef) this.zweef.remove();
        if (this.media) this.media.removeEventListener('change', this.opMedia);
        document.removeEventListener('click', this.opKlik);
        document.removeEventListener('change', this.opWijzig);
        document.removeEventListener('shopify:section:select', this.opSelect);
        this.lade.removeEventListener('theme-drawer:open', this.opOpen);
        this.comp.removeAttribute('data-sora-cd');
        if (this.autoOrigineel) this.comp.setAttribute('auto-open', '');
        else this.comp.removeAttribute('auto-open');
      }

      /* Na elke morph van Horizon: teksten en regels opnieuw invullen. Het observeren staat even uit, zodat eigen wijzigingen geen lus geven. */
      bijwerken() {
        if (!this.gestart) return;
        this.obs.disconnect();
        try {
          this.titel();
          this.knopTekst();
          const sam = this.dialog.querySelector('[data-sora-cds]');
          if (sam) this.samenvatting(sam);
          this.badges();
          this.kortingscode();
          this.volgKnop();
        } finally {
          this.obs.observe(this.dialog, LEES_OPTIES);
        }
      }

      titel() {
        const tekst = this.config.titel;
        if (!tekst) return;
        const kop = this.dialog.querySelector('.cart-drawer__inner:not(.cart-drawer--empty) .theme-drawer__title');
        if (!kop) return;
        const knoop = Array.from(kop.childNodes).find((n) => n.nodeType === 3 && n.nodeValue.trim() !== '');
        if (knoop && knoop.nodeValue.trim() !== tekst) knoop.nodeValue = tekst + ' ';
      }

      knopTekst() {
        const tekst = this.config.knopTekst;
        const knop = this.dialog.querySelector('.cart__checkout-button .button-text');
        if (tekst && knop && knop.textContent.trim() !== tekst) knop.textContent = tekst;
      }

      /* Alleen schrijven als de inhoud echt anders is (de browser schrijft HTML soms anders terug dan hij is gezet) */
      zet(el, html) {
        if (!el) return;
        if (!this.geschreven) this.geschreven = new WeakMap();
        const vorig = this.geschreven.get(el);
        if (vorig && vorig.html === html && vorig.dom === el.innerHTML) return;
        if (el.innerHTML !== html) el.innerHTML = html;
        this.geschreven.set(el, { html, dom: el.innerHTML });
      }

      samenvatting(el) {
        const c = this.config.verzend;
        const fmt = this.config.geldFormaat;
        const totaal = Number(el.dataset.totaal) || 0;
        const verzendt = el.dataset.verzenden !== 'false';
        if (el.hidden) el.hidden = false;

        const korting = Number(el.dataset.korting) || 0;
        const subLabel = korting > 0 && c.subLabelKorting ? c.subLabelKorting : c.subLabel;
        this.zet(el.querySelector('[data-sora-cds-label="sub"]'), esc(subLabel));
        this.zet(el.querySelector('[data-sora-cds-label="korting"]'), esc(c.kortingLabel || ''));
        const kortingRij = el.querySelector('[data-sora-cds-rij="korting"]');
        if (kortingRij) kortingRij.hidden = !(korting > 0 && c.kortingLabel);
        this.zet(el.querySelector('[data-sora-cds-label="verzend"]'), esc(c.label));
        this.zet(el.querySelector('[data-sora-cds-label="totaal"]'), esc(c.totaalLabel));
        const sub = el.querySelector('[data-sora-cds-rij="sub"]');
        if (sub) sub.hidden = !subLabel;

        const toon = Boolean(c.tonen) && verzendt;
        const kosten = bedrag(c.kosten);
        const drempel = bedrag(c.drempel);
        const gratis = kosten === 0 || (drempel > 0 && totaal >= drempel);

        const rij = el.querySelector('[data-sora-cds-rij="verzend"]');
        if (rij) rij.hidden = !toon;
        if (toon) {
          let waarde;
          if (gratis) {
            waarde = (c.doorgestreept && kosten > 0 ? '<s>' + esc(geld(kosten, fmt)) + '</s>' : '') + '<span class="sora-cds__gratis-tekst">' + esc(c.gratis) + '</span>';
          } else {
            waarde = '<bdi>' + esc(geld(kosten, fmt)) + '</bdi>';
          }
          this.zet(el.querySelector('[data-sora-cds-verzend]'), waarde);
        }

        const blok = el.querySelector('[data-sora-cds-gratis]');
        const melding = el.querySelector('[data-sora-cds-melding]');
        const balk = el.querySelector('[data-sora-cds-balk]');
        const metDrempel = toon && drempel > 0 && kosten > 0;
        if (metDrempel && melding) {
          const rest = drempel - totaal;
          const html = gratis ? esc(c.tekstGratis) : sjabloon(c.tekstNog, { bedrag: '<strong>' + esc(geld(rest, fmt)) + '</strong>' });
          this.zet(melding, html);
          melding.classList.toggle('sora-cds__melding--gratis', gratis);
          melding.hidden = !html;
        }
        if (balk) {
          balk.hidden = !(metDrempel && c.balk);
          const procent = Math.min(100, Math.round((totaal / Math.max(drempel, 1)) * 100));
          if (balk.style.getPropertyValue('--sora-cds-voortgang') !== procent + '%') balk.style.setProperty('--sora-cds-voortgang', procent + '%');
        }
        if (blok) blok.hidden = !metDrempel || ((!melding || melding.hidden) && (!balk || balk.hidden));

        const eind = totaal + (toon && c.totaalMetVerzending && !gratis ? kosten : 0);
        this.zet(el.querySelector('[data-sora-cds-totaal]'), '<bdi>' + esc(geld(eind, fmt)) + '</bdi>');
        this.zet(el.querySelector('[data-sora-cds-noot]'), esc(c.noot || ''));

        this.tijd(el.querySelector('[data-sora-cds-tijd]'), verzendt);
      }

      /* Kortingsbadge achter de prijs van elke regel: het percentage komt uit de regel, de tekst uit de sectie */
      badges() {
        const sjab = this.config.badge;
        this.dialog.querySelectorAll('[data-sora-cdl-badge]').forEach((b) => {
          const tekst = sjab ? sjab.split('{percentage}').join(b.dataset.procent || '') : '';
          if (b.textContent !== tekst) b.textContent = tekst;
          if (b.hidden !== !tekst) b.hidden = !tekst;
        });
      }

      /* Kortingscodeveld zonder uitklapregel: het uitklapblok van Horizon staat altijd open */
      kortingscode() {
        if (!this.config.kortingscodeOpen) return;
        const d = this.dialog.querySelector('.cart-discount details');
        if (d && !d.open) d.open = true;
      }

      tijd(el, verzendt) {
        if (!el) return;
        const t = this.config.tijd;
        const moment = t.tonen && verzendt ? verzendMoment(t, new Date()) : null;
        if (!moment) {
          this.zet(el, '');
          return;
        }
        let tekst;
        if (moment.vandaag) {
          const metSec = String(t.uren + t.minuten).includes('{s}');
          const totaalMin = metSec ? Math.floor(moment.seconden / 60) : Math.ceil(moment.seconden / 60);
          const u = Math.floor(totaalMin / 60);
          const m = totaalMin % 60;
          const sec = moment.seconden % 60;
          const notatie = (u > 0 ? t.uren : t.minuten).split('{u}').join(String(u)).split('{m}').join(String(m)).split('{s}').join(String(sec).padStart(2, '0'));
          tekst = sjabloon(t.tekstVandaag, { tijd: '<strong>' + esc(notatie) + '</strong>' });
        } else {
          tekst = sjabloon(t.tekstLater, { dag: '<strong>' + esc(moment.dag) + '</strong>' });
        }
        this.zet(el, (t.icoon ? TRUCK : '') + '<span>' + tekst + '</span>');
      }

      /* Zwevende bestelknop: alleen zichtbaar als de echte knop onder de rand van de lade valt */
      maakZweef() {
        const stand = this.config.zweven;
        if (!stand || stand === 'uit') return;
        this.media = window.matchMedia(stand === 'mobiel' ? '(max-width: 749px)' : 'all');
        this.opMedia = () => this.zweefStand();
        this.media.addEventListener('change', this.opMedia);

        const zweef = document.createElement('div');
        zweef.className = 'sora-cd-zweef';
        zweef.hidden = true;
        zweef.innerHTML = '<button type="button" class="button sora-cd-zweef__knop" tabindex="-1" aria-hidden="true"></button>';
        zweef.firstChild.addEventListener('click', () => {
          const echt = this.dialog.querySelector('.cart__checkout-button');
          if (echt && !echt.disabled) echt.click();
        });
        this.dialog.appendChild(zweef);
        this.zweef = zweef;
        this.knopZichtbaar = true;
        this.zicht = new IntersectionObserver((items) => {
          items.forEach((item) => {
            this.knopZichtbaar = item.isIntersecting || item.boundingClientRect.top < (item.rootBounds ? item.rootBounds.top : 0);
          });
          this.zweefStand();
        });
      }

      volgKnop() {
        if (!this.zicht) return;
        const echt = this.dialog.querySelector('.cart__checkout-button');
        if (echt !== this.gevolgd) {
          if (this.gevolgd) this.zicht.unobserve(this.gevolgd);
          this.gevolgd = echt;
          if (echt) this.zicht.observe(echt);
          else this.knopZichtbaar = true;
        }
        this.zweefStand();
      }

      zweefStand() {
        if (!this.zweef) return;
        const echt = this.gevolgd;
        const leeg = Boolean(this.dialog.querySelector('.cart-drawer--empty'));
        const toon = Boolean(echt) && !leeg && this.media.matches && !this.knopZichtbaar;
        if (this.zweef.hidden === toon) this.zweef.hidden = !toon;
        if (echt) {
          const tekst = echt.textContent.trim();
          const knop = this.zweef.firstChild;
          if (knop.textContent !== tekst) knop.textContent = tekst;
        }
      }

      /* Maatwissel */
      klik(e) {
        const knop = e.target.closest && e.target.closest('[data-sora-cdl-variant]');
        if (!knop || !this.lade.contains(knop)) return;
        e.preventDefault();
        if (knop.disabled || knop.getAttribute('aria-pressed') === 'true') return;
        this.wissel(knop.closest('[data-sora-cdl]'), knop.dataset.soraCdlVariant);
      }

      wijzig(e) {
        const lijst = e.target.closest && e.target.closest('[data-sora-cdl-lijst]');
        if (!lijst || !this.lade.contains(lijst)) return;
        this.wissel(lijst.closest('[data-sora-cdl]'), lijst.value);
      }

      async wissel(regel, nieuwId) {
        if (!regel || regel.dataset.bezig || !nieuwId || nieuwId === regel.dataset.variant) return;
        const rij = regel.closest('.cart-items__table-row');
        const fout = regel.querySelector('[data-sora-cdl-fout]');
        const oudKey = regel.dataset.key;
        const aantal = Number(regel.dataset.aantal) || 1;
        regel.dataset.bezig = '1';
        if (rij) rij.classList.add('sora-cdl-bezig');
        if (fout) fout.textContent = '';

        const updates = {};
        updates[oudKey] = 0;
        const zelfde = Array.from(this.lade.querySelectorAll('[data-sora-cdl]')).find((r) => r !== regel && r.dataset.variant === nieuwId);
        if (zelfde) updates[zelfde.dataset.key] = (Number(zelfde.dataset.aantal) || 0) + aantal;
        else updates[nieuwId] = aantal;

        const secties = Array.from(document.querySelectorAll('cart-items-component'))
          .map((c) => c.dataset.sectionId)
          .filter(Boolean)
          .join(',');

        const ev = await laadEvents();
        let uitgesteld = null;
        if (ev && ev.CartLinesUpdateEvent) {
          try {
            uitgesteld = ev.CartLinesUpdateEvent.createPromise();
            regel.dispatchEvent(
              new ev.CartLinesUpdateEvent({
                action: 'update',
                context: 'cart',
                lines: [
                  { id: oudKey, quantity: 0 },
                  { merchandiseId: String(nieuwId), quantity: aantal },
                ],
                promise: uitgesteld.promise,
              })
            );
          } catch (fout2) {
            uitgesteld = null;
          }
        }

        const routes = (typeof Theme !== 'undefined' && Theme.routes) || (window.Theme && window.Theme.routes) || {};
        const url = (routes.cart_update_url || '/cart/update') + '.js';
        let data = null;
        let gelukt = false;
        try {
          const antwoord = await fetch(url.replace('.js.js', '.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates, sections: secties || undefined }),
          });
          data = await antwoord.json().catch(() => null);
          gelukt = antwoord.ok && data && !data.status && Array.isArray(data.items);
        } catch (fout3) {
          gelukt = false;
        }

        if (gelukt && uitgesteld) {
          uitgesteld.resolve({
            cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(data),
            detail: {
              items: data.items,
              itemCount: data.item_count,
              sections: data.sections,
              source: 'sora-winkelwagenlade',
              didError: false,
            },
          });
          return;
        }
        if (gelukt) {
          window.location.reload();
          return;
        }

        if (uitgesteld) uitgesteld.reject(new Error((data && (data.description || data.message)) || 'Maat wisselen mislukt'));
        delete regel.dataset.bezig;
        if (rij) rij.classList.remove('sora-cdl-bezig');
        const lijst = regel.querySelector('[data-sora-cdl-lijst]');
        if (lijst) lijst.value = regel.dataset.variant;
        if (fout) fout.textContent = (data && data.description) || this.config.maatFout;
      }
    }

    customElements.define('sora-winkelwagenlade', SoraWinkelwagenlade);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-cart-upsell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sora-cart-upsell')) return;

    const routes = () => {
      const r = (typeof Theme !== 'undefined' && Theme.routes) || (window.Theme && window.Theme.routes) || {};
      const winkelwagen = r.cart_url || '/cart';
      return { toevoegen: r.cart_add_url || '/cart/add.js', winkelwagen, json: winkelwagen + '.js' };
    };

    let events = null;
    const laadEvents = async () => {
      if (events !== null) return events;
      try {
        events = await import('@shopify/events');
      } catch (fout) {
        events = false;
      }
      return events;
    };

    const postJson = async (url, body) => {
      const antwoord = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await antwoord.json().catch(() => ({}));
      return { ok: antwoord.ok && !data.status, data };
    };

    /* Voegt een variant toe en laat Horizon (lade, teller) meelopen via de cartevents */
    const voegToe = async (variantId, bron) => {
      const r = routes();
      const ev = await laadEvents();
      let uitgesteld = null;
      if (ev && ev.CartLinesUpdateEvent) {
        try {
          uitgesteld = ev.CartLinesUpdateEvent.createPromise();
          bron.dispatchEvent(
            new ev.CartLinesUpdateEvent({
              action: 'add',
              context: 'cart',
              lines: [{ merchandiseId: String(variantId), quantity: 1 }],
              promise: uitgesteld.promise,
            })
          );
        } catch (fout) {
          uitgesteld = null;
        }
      }

      const sectieIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((c) => c.dataset.sectionId)
        .filter(Boolean)
        .join(',');

      let gelukt = false;
      let secties;
      try {
        const resultaat = await postJson(r.toevoegen, {
          items: [{ id: variantId, quantity: 1 }],
          sections: sectieIds || undefined,
        });
        gelukt = resultaat.ok;
        secties = resultaat.data.sections;
      } catch (fout) {
        gelukt = false;
      }

      if (uitgesteld) {
        let wagen = null;
        try {
          const antwoord = await fetch(r.json, { headers: { Accept: 'application/json' } });
          wagen = await antwoord.json();
        } catch (fout) {
          wagen = null;
        }
        if (wagen && wagen.items) {
          uitgesteld.resolve({
            cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(wagen),
            detail: {
              items: wagen.items,
              source: 'sora-anderen-kochten-ook',
              itemCount: wagen.item_count,
              sections: secties,
              didError: !gelukt,
            },
          });
        } else {
          uitgesteld.reject(new Error('Winkelwagen niet opgehaald'));
        }
      } else if (gelukt) {
        window.location.assign(r.winkelwagen);
      }
      return gelukt;
    };

    const maakPrijs = (doel, variant, kortingSjabloon) => {
      doel.textContent = '';
      const nu = document.createElement('span');
      nu.className = 'sora-cu-kaart__nu';
      nu.textContent = variant.prijs;
      doel.appendChild(nu);
      doel.classList.toggle('sora-cu-kaart__prijs--actie', Boolean(variant.verprijs));
      if (variant.verprijs) {
        const oud = document.createElement('s');
        oud.className = 'sora-cu-kaart__oud';
        oud.textContent = variant.verprijs;
        doel.appendChild(oud);
        if (kortingSjabloon && variant.verprijsCent > variant.prijsCent) {
          const procent = Math.max(1, Math.round(((variant.verprijsCent - variant.prijsCent) * 100) / variant.verprijsCent));
          const badge = document.createElement('span');
          badge.className = 'sora-cu-badge';
          badge.textContent = kortingSjabloon.split('{percentage}').join(String(procent));
          doel.appendChild(badge);
        }
      }
    };

    const optieLabel = (sjabloon, naam) => {
      const plek = (sjabloon || '').indexOf('{optie}');
      if (plek === -1) return naam;
      return sjabloon.split('{optie}').join(plek > 0 ? naam.toLowerCase() : naam);
    };

    let actief = null;

    /* Pop-up: een per lade, in het lade-dialoog zelf zodat de focusval van Horizon hem meeneemt */
    const Popup = {
      dialog: null,
      kaart: null,
      keuze: [],

      maak(houder) {
        if (this.dialog && this.dialog.isConnected) {
          if (this.dialog.parentNode !== houder) houder.appendChild(this.dialog);
          return;
        }
        const d = document.createElement('dialog');
        d.className = 'sora-cu-popup';
        d.innerHTML =
          '<div class="sora-cu-popup__binnen">' +
          '<button type="button" class="sora-cu-popup__sluit" data-sluit><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
          '<div class="sora-cu-popup__kop"><img class="sora-cu-popup__beeld" alt="" hidden><div><p class="sora-cu-popup__titel"></p><p class="sora-cu-popup__prijs"></p></div></div>' +
          '<div class="sora-cu-popup__opties"></div>' +
          '<p class="sora-cu-popup__fout" role="status" aria-live="polite"></p>' +
          '<button type="button" class="sora-cu-popup__knop" data-voegtoe></button>' +
          '</div>';

        d.addEventListener('click', (e) => {
          e.stopPropagation();
          if (e.target === d || e.target.closest('[data-sluit]')) {
            d.close();
            return;
          }
          const waarde = e.target.closest('[data-popup-waarde]');
          if (waarde && !waarde.disabled) {
            this.kies(Number(waarde.dataset.optie), waarde.dataset.popupWaarde);
            return;
          }
          if (e.target.closest('[data-voegtoe]')) this.toevoegen();
        });
        /* Escape sluit alleen de pop-up, niet de lade */
        d.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape') return;
          e.preventDefault();
          d.close();
        });
        d.addEventListener('close', () => {
          const knop = this.kaart && this.kaart.querySelector('[data-sora-cu-snel]');
          if (knop && knop.isConnected) knop.focus();
        });
        houder.appendChild(d);
        this.dialog = d;
      },

      past(v, negeer) {
        return this.keuze.every((k, j) => j === negeer || k === null || v.opties[j] === k);
      },

      open(kaart, houder, tekst) {
        this.maak(houder);
        this.kaart = kaart;
        this.tekst = tekst;
        const data = kaart.data;
        const d = this.dialog;
        d.setAttribute('aria-label', data.titel);
        d.querySelector('.sora-cu-popup__titel').textContent = data.titel;
        d.querySelector('[data-sluit]').setAttribute('aria-label', tekst.sluiten);
        d.querySelector('.sora-cu-popup__fout').textContent = '';

        this.keuze = data.opties.map(() => null);
        if (kaart.keuze !== null) this.keuze[0] = kaart.keuze;
        data.opties.forEach((optie, i) => {
          if (this.keuze[i] !== null) return;
          const mogelijk = this.waarden(i);
          if (mogelijk.length === 1) this.keuze[i] = mogelijk[0].naam;
        });

        this.teken();
        if (!d.open) d.showModal();
      },

      waarden(i) {
        const data = this.kaart.data;
        return data.opties[i].waarden.filter((w) => data.varianten.some((v) => v.beschikbaar && v.opties[i] === w.naam));
      },

      kies(i, naam) {
        const data = this.kaart.data;
        this.keuze[i] = this.keuze[i] === naam ? null : naam;
        data.opties.forEach((optie, j) => {
          if (j === i || this.keuze[j] === null) return;
          const kan = data.varianten.some((v) => v.beschikbaar && this.past(v, -1));
          if (!kan) this.keuze[j] = null;
        });
        this.dialog.querySelector('.sora-cu-popup__fout').textContent = '';
        this.teken();
      },

      variant() {
        if (this.keuze.some((k) => k === null)) return null;
        return this.kaart.data.varianten.find((v) => this.past(v, -1)) || null;
      },

      teken() {
        const data = this.kaart.data;
        const d = this.dialog;
        const opties = d.querySelector('.sora-cu-popup__opties');
        opties.textContent = '';

        data.opties.forEach((optie, i) => {
          const groep = document.createElement('div');
          groep.setAttribute('role', 'group');
          groep.setAttribute('aria-label', optie.naam);
          const naam = document.createElement('p');
          naam.className = 'sora-cu-popup__naam';
          naam.textContent = optieLabel(this.tekst.optie, optie.naam) + (this.keuze[i] ? ': ' : '');
          if (this.keuze[i]) {
            const gekozen = document.createElement('span');
            gekozen.textContent = this.keuze[i];
            naam.appendChild(gekozen);
          }
          const rij = document.createElement('div');
          rij.className = 'sora-cu-popup__rij';

          this.waarden(i).forEach((w) => {
            const knop = document.createElement('button');
            knop.type = 'button';
            knop.className = 'sora-cu-popup__waarde';
            knop.dataset.optie = String(i);
            knop.dataset.popupWaarde = w.naam;
            knop.setAttribute('aria-pressed', this.keuze[i] === w.naam ? 'true' : 'false');
            const kan = data.varianten.some(
              (v) => v.beschikbaar && v.opties[i] === w.naam && this.keuze.every((k, j) => j >= i || k === null || v.opties[j] === k)
            );
            knop.disabled = !kan;
            if (optie.type === 'bolletjes' && (w.beeld || w.kleur)) {
              knop.classList.add('sora-cu-popup__waarde--bol');
              knop.setAttribute('aria-label', w.naam);
              knop.title = w.naam;
              if (w.beeld) knop.style.backgroundImage = 'url("' + w.beeld + '")';
              else knop.style.backgroundColor = w.kleur;
            } else {
              knop.textContent = w.naam;
            }
            rij.appendChild(knop);
          });

          groep.append(naam, rij);
          opties.appendChild(groep);
        });

        const v = this.variant();
        const voorbeeld = v || data.varianten.find((x) => x.beschikbaar && this.past(x, -1)) || data.varianten[0];
        const prijs = d.querySelector('.sora-cu-popup__prijs');
        if (voorbeeld) maakPrijs(prijs, voorbeeld, this.tekst.korting);
        const beeld = d.querySelector('.sora-cu-popup__beeld');
        const bron = (voorbeeld && voorbeeld.beeld) || data.beeld;
        if (bron) {
          beeld.src = bron;
          beeld.hidden = false;
        } else {
          beeld.hidden = true;
        }

        const knop = d.querySelector('[data-voegtoe]');
        knop.textContent = this.tekst.knop;
        knop.disabled = !(v && v.beschikbaar);
      },

      async toevoegen() {
        const v = this.variant();
        if (!v || !v.beschikbaar) return;
        const knop = this.dialog.querySelector('[data-voegtoe]');
        knop.disabled = true;
        knop.textContent = this.tekst.bezig;
        const gelukt = await voegToe(v.id, this.kaart);
        if (gelukt) {
          this.dialog.close();
        } else {
          this.dialog.querySelector('.sora-cu-popup__fout').textContent = this.tekst.fout;
          this.teken();
        }
      },
    };

    class SoraCuKaart extends HTMLElement {
      connectedCallback() {
        if (this.klaar) return;
        this.klaar = true;
        this.keuze = null;
        try {
          const bron = this.querySelector('[data-sora-cu-data]');
          this.data = bron ? JSON.parse(bron.textContent) : null;
        } catch (fout) {
          this.data = null;
        }
        const prijs = this.querySelector('[data-sora-cu-prijs]');
        this.prijsOrigineel = prijs ? prijs.innerHTML : '';
        this.prijsKlasse = prijs ? prijs.className : '';

        this.addEventListener('click', (e) => this.opKlik(e));
        this.addEventListener('change', (e) => {
          const select = e.target.closest('[data-sora-cu-select]');
          if (select) this.kies(select.value || null);
        });

        if (this.data && this.data.varianten.length > 1) {
          const op = this.data.varianten.filter((v) => v.beschikbaar);
          if (op.length === 1) this.kies(op[0].opties[0]);
        }
      }

      opKlik(e) {
        const waarde = e.target.closest('[data-sora-cu-waarde]');
        if (waarde) {
          e.preventDefault();
          const naam = waarde.dataset.soraCuWaarde;
          this.kies(this.keuze === naam ? null : naam);
          return;
        }
        const snel = e.target.closest('[data-sora-cu-snel]');
        if (snel) {
          e.preventDefault();
          if (!snel.disabled && snel.dataset.status !== 'bezig') this.snel(snel);
        }
      }

      kandidaten(naam) {
        if (!this.data || naam === null) return [];
        return this.data.varianten.filter((v) => v.beschikbaar && v.opties[0] === naam);
      }

      vasteVariant() {
        if (!this.data) return null;
        const alle = this.data.varianten;
        if (alle.length === 1) return alle[0];
        if (this.keuze === null) return null;
        const kandidaten = this.kandidaten(this.keuze);
        if (this.data.opties.length === 1 || kandidaten.length === 1) return kandidaten[0] || null;
        return null;
      }

      kies(naam) {
        this.keuze = naam;
        this.querySelectorAll('[data-sora-cu-waarde]').forEach((knop) => {
          knop.setAttribute('aria-pressed', knop.dataset.soraCuWaarde === naam ? 'true' : 'false');
        });
        const select = this.querySelector('[data-sora-cu-select]');
        if (select && select.value !== (naam || '')) select.value = naam || '';
        const melding = this.querySelector('[data-sora-cu-melding]');
        if (melding) melding.textContent = '';
        this.toonVariant(this.kandidaten(naam)[0] || null);
      }

      toonVariant(v) {
        const prijs = this.querySelector('[data-sora-cu-prijs]');
        if (prijs) {
          if (v) maakPrijs(prijs, v, prijs.dataset.soraCuBadge);
          else {
            prijs.innerHTML = this.prijsOrigineel;
            prijs.className = this.prijsKlasse;
          }
        }
        const beeld = this.querySelector('img.sora-cu-kaart__beeld');
        if (beeld) {
          if (beeld.dataset.soraCuSrc === undefined) {
            beeld.dataset.soraCuSrc = beeld.getAttribute('src') || '';
            beeld.dataset.soraCuSrcset = beeld.getAttribute('srcset') || '';
          }
          const nieuwSrc = v && v.beeld ? v.beeld : beeld.dataset.soraCuSrc;
          const nieuwSet = v && v.beeld ? v.srcset || '' : beeld.dataset.soraCuSrcset;
          if (nieuwSet) beeld.setAttribute('srcset', nieuwSet);
          else beeld.removeAttribute('srcset');
          beeld.setAttribute('src', nieuwSrc);
        }
        this.querySelectorAll('a[href]').forEach((link) => {
          if (link.classList.contains('sora-cu-kaart__meer')) return;
          if (link.dataset.soraCuHref === undefined) link.dataset.soraCuHref = link.getAttribute('href') || '';
          link.setAttribute('href', v && v.url ? v.url : link.dataset.soraCuHref);
        });
      }

      async snel(knop) {
        if (!this.data || !actief) return;
        const v = this.vasteVariant();
        if (!v) {
          Popup.open(this, actief.dialog, actief.config.tekst);
          return;
        }
        if (!v.beschikbaar) return;
        knop.dataset.status = 'bezig';
        const gelukt = await voegToe(v.id, this);
        if (!knop.isConnected) return;
        delete knop.dataset.status;
        if (gelukt) {
          knop.dataset.status = 'klaar';
          setTimeout(() => {
            if (knop.dataset.status === 'klaar') delete knop.dataset.status;
          }, 1800);
        } else {
          const melding = this.querySelector('[data-sora-cu-melding]');
          if (melding) melding.textContent = actief.config.tekst.fout;
        }
      }
    }

    customElements.define('sora-cu-kaart', SoraCuKaart);

    const PIJL = (richting) =>
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      (richting === 'vorige' ? '<path d="M19 12H5M11 6l-6 6 6 6"/>' : '<path d="M5 12h14M13 6l6 6-6 6"/>') +
      '</svg>';

    class SoraCartUpsell extends HTMLElement {
      connectedCallback() {
        if (this.gestart) return;
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
          return;
        }
        try {
          this.config = JSON.parse(this.querySelector('[data-sora-cu-config]').textContent);
        } catch (fout) {
          return;
        }
        this.lade = document.getElementById('cart-drawer');
        this.dialog = this.lade && this.lade.querySelector('dialog');
        if (!this.lade || !this.dialog) return;
        this.gestart = true;
        actief = this;
        this.cache = new Map();
        this.sleutel = null;
        this.aanvraag = 0;

        this.maakDoos();
        this.media = window.matchMedia('(min-width: 990px)');
        this.opMedia = () => this.plaats();
        this.media.addEventListener('change', this.opMedia);
        const eigen = (n) => {
          const el = n && (n.nodeType === 1 ? n : n.parentElement);
          return Boolean(el && el.closest('.sora-cu, .sora-cu-popup, .sora-cd-zweef, [data-sora-cds]'));
        };
        this.obs = new MutationObserver((lijst) => {
          if (lijst.every((m) => eigen(m.target) && m.type !== 'attributes')) return;
          this.plaats();
        });
        this.obs.observe(this.dialog, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-producten'] });
        this.opSelect = (e) => {
          if (e.detail && e.detail.sectionId === this.config.sectie && typeof this.lade.open === 'function') this.lade.open();
        };
        document.addEventListener('shopify:section:select', this.opSelect);
        this.opOpen = () => this.plaats();
        this.lade.addEventListener('theme-drawer:open', this.opOpen);
        this.plaats();
      }

      disconnectedCallback() {
        if (!this.gestart) return;
        this.gestart = false;
        if (actief === this) actief = null;
        this.obs.disconnect();
        this.media.removeEventListener('change', this.opMedia);
        document.removeEventListener('shopify:section:select', this.opSelect);
        this.lade.removeEventListener('theme-drawer:open', this.opOpen);
        this.maat.disconnect();
        this.doos.remove();
        if (Popup.dialog && Popup.dialog.open) Popup.dialog.close();
      }

      maakDoos() {
        const doos = document.createElement('div');
        doos.className = 'sora-cu sora-cu--rij';
        doos.hidden = true;
        doos.setAttribute('role', 'region');
        doos.setAttribute('aria-label', this.config.tekst.regio);
        const kop = this.querySelector('template[data-sora-cu-kop]');
        if (kop) doos.appendChild(kop.content.cloneNode(true));
        const venster = document.createElement('div');
        venster.className = 'sora-cu__venster';
        this.lijst = document.createElement('ul');
        this.lijst.className = 'sora-cu__lijst';
        venster.appendChild(this.lijst);
        doos.appendChild(venster);

        const nav = document.createElement('div');
        nav.className = 'sora-cu__nav';
        nav.innerHTML =
          '<button type="button" class="sora-cu__pijl" data-richting="vorige">' + PIJL('vorige') + '</button>' +
          '<div class="sora-cu__stippen"></div>' +
          '<button type="button" class="sora-cu__pijl" data-richting="volgende">' + PIJL('volgende') + '</button>';
        nav.querySelector('[data-richting="vorige"]').setAttribute('aria-label', this.config.tekst.vorige);
        nav.querySelector('[data-richting="volgende"]').setAttribute('aria-label', this.config.tekst.volgende);
        nav.querySelectorAll('.sora-cu__pijl').forEach((p) => {
          p.hidden = !this.config.pijlen;
        });
        nav.querySelector('.sora-cu__stippen').hidden = !this.config.stippen;
        nav.addEventListener('click', (e) => {
          const pijl = e.target.closest('.sora-cu__pijl');
          if (pijl) {
            this.schuif(pijl.dataset.richting === 'vorige' ? -1 : 1);
            return;
          }
          const stip = e.target.closest('.sora-cu__stip');
          if (stip) this.naarPagina(Number(stip.dataset.pagina));
        });
        doos.appendChild(nav);
        this.nav = nav;
        this.stippen = nav.querySelector('.sora-cu__stippen');

        let wacht = false;
        this.lijst.addEventListener(
          'scroll',
          () => {
            if (wacht) return;
            wacht = true;
            requestAnimationFrame(() => {
              wacht = false;
              this.navStand();
            });
          },
          { passive: true }
        );
        this.doos = doos;
        this.maat = new ResizeObserver(() => this.navStand());
        this.maat.observe(this.lijst);
      }

      /* Plek in de lade of paneel naast de lade; laadt nieuwe aanbevelingen als de winkelwagen verandert */
      plaats() {
        if (!this.gestart) return;
        this.obs.disconnect();
        try {
          const plek = this.dialog.querySelector('[data-sora-cu-plek]');
          if (!plek) {
            if (this.doos.parentNode) this.doos.remove();
            this.doos.hidden = true;
            this.sleutel = null;
            return;
          }
          const paneel = this.config.desktop === 'paneel' && this.media.matches;
          const doel = paneel ? this.dialog : plek;
          if (this.doos.parentNode !== doel) doel.appendChild(this.doos);
          if (this.doos.classList.contains('sora-cu--paneel') !== paneel) {
            this.doos.classList.toggle('sora-cu--paneel', paneel);
            this.doos.classList.toggle('sora-cu--rij', !paneel);
          }
          if (paneel && plek.firstChild) plek.textContent = '';
          const sleutel = plek.dataset.producten || '';
          /* Pas laden als de lade open is: geen extra verzoeken bij elke paginaweergave */
          if (sleutel !== this.sleutel && this.lade.hasAttribute('open')) {
            this.sleutel = sleutel;
            this.laad(sleutel);
          }
          this.navStand();
        } finally {
          this.obs.observe(this.dialog, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-producten'] });
        }
      }

      async haal(productId, intent, limiet) {
        const sleutel = productId + '|' + intent + '|' + limiet;
        if (this.cache.has(sleutel)) return this.cache.get(sleutel);
        const url =
          this.config.url +
          '?product_id=' + encodeURIComponent(productId) +
          '&limit=' + limiet +
          '&section_id=' + encodeURIComponent(this.config.sectie) +
          '&intent=' + intent;
        const belofte = fetch(url)
          .then((a) => (a.ok ? a.text() : ''))
          .then((html) => {
            if (!html) return [];
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return Array.from(doc.querySelectorAll('[data-sora-cu-item]'));
          })
          .catch(() => []);
        this.cache.set(sleutel, belofte);
        return belofte;
      }

      async laad(sleutel) {
        const nummer = ++this.aanvraag;
        const inWagen = sleutel ? sleutel.split(',').filter(Boolean) : [];
        if (inWagen.length === 0) {
          this.toon([]);
          return;
        }
        const basis = this.config.basis === 'eerste' ? inWagen.slice(0, 1) : inWagen.slice(0, 3);
        const limiet = Math.min(10, this.config.aantal + inWagen.length);
        const verzamel = async (intent) => {
          const lijsten = await Promise.all(basis.map((id) => this.haal(id, intent, limiet)));
          const gezien = new Set(this.config.verberg ? inWagen : []);
          const uit = [];
          const max = Math.max(...lijsten.map((l) => l.length), 0);
          for (let i = 0; i < max; i += 1) {
            lijsten.forEach((l) => {
              const item = l[i];
              if (!item) return;
              const id = item.dataset.productId;
              if (gezien.has(id)) return;
              gezien.add(id);
              uit.push(item);
            });
          }
          return uit;
        };
        let items = await verzamel(this.config.intent);
        if (items.length === 0 && this.config.intent !== 'related') items = await verzamel('related');
        if (nummer !== this.aanvraag || !this.gestart) return;
        this.toon(items.slice(0, this.config.aantal));
      }

      toon(items) {
        this.obs.disconnect();
        try {
          this.lijst.replaceChildren(...items.map((item) => document.importNode(item, true)));
          this.lijst.scrollLeft = 0;
          this.doos.hidden = items.length === 0;
          this.navStand();
        } finally {
          this.obs.observe(this.dialog, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-producten'] });
        }
      }

      perPagina() {
        return Math.max(1, Math.floor(Number(this.config.perBeeld) || 2));
      }

      paginas() {
        const aantal = this.lijst.children.length;
        return Math.max(1, Math.ceil(aantal / this.perPagina()));
      }

      schuif(richting) {
        const item = this.lijst.firstElementChild;
        if (!item) return;
        const stap = (item.getBoundingClientRect().width + 12) * this.perPagina();
        this.lijst.scrollBy({ left: richting * stap, behavior: 'smooth' });
      }

      naarPagina(p) {
        const item = this.lijst.children[p * this.perPagina()];
        if (item) this.lijst.scrollTo({ left: item.offsetLeft - this.lijst.offsetLeft, behavior: 'smooth' });
      }

      navStand() {
        if (!this.nav) return;
        const rij = this.doos.classList.contains('sora-cu--rij');
        const meer = this.lijst.scrollWidth > this.lijst.clientWidth + 2;
        const verberg = !rij || !meer || (!this.config.pijlen && !this.config.stippen);
        if (this.nav.hidden !== verberg) this.nav.hidden = verberg;
        if (verberg) return;
        const max = this.lijst.scrollWidth - this.lijst.clientWidth;
        const links = Math.abs(this.lijst.scrollLeft);
        const [vorige, volgende] = this.nav.querySelectorAll('.sora-cu__pijl');
        if (vorige.disabled !== links <= 2) vorige.disabled = links <= 2;
        if (volgende.disabled !== links >= max - 2) volgende.disabled = links >= max - 2;

        const totaal = this.paginas();
        if (this.stippen.children.length !== totaal) {
          this.stippen.textContent = '';
          for (let i = 0; i < totaal; i += 1) {
            const stip = document.createElement('button');
            stip.type = 'button';
            stip.className = 'sora-cu__stip';
            stip.dataset.pagina = String(i);
            stip.setAttribute('aria-label', String(this.config.tekst.stip || '').split('{nummer}').join(String(i + 1)));
            this.stippen.appendChild(stip);
          }
        }
        const huidig = links >= max - 2 ? totaal - 1 : Math.round((links / Math.max(max, 1)) * (totaal - 1));
        Array.from(this.stippen.children).forEach((stip, i) => {
          const waarde = i === huidig ? 'true' : 'false';
          if (stip.getAttribute('aria-current') !== waarde) stip.setAttribute('aria-current', waarde);
        });
      }
    }

    customElements.define('sora-cart-upsell', SoraCartUpsell);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-collection-chips"] && !Shopify.designMode) return;
  try {
    
  /* Zet de chip-waarde in/uit de filter-parameter van de huidige URL, zodat filters die na het laden
     zijn gekozen blijven staan. Zonder JavaScript werkt de gewone link (server-URL). */
  if (!window.soraCollectionChipsGeladen) {
    window.soraCollectionChipsGeladen = true;

    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[data-sora-chip-param]') : null;
      if (!link || event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const param = link.dataset.soraChipParam;
      const waarde = link.dataset.soraChipWaarde || '';
      const url = new URL(window.location.href);
      let waarden = (url.searchParams.get(param) || '').split(',').filter(Boolean);

      if (waarde === '') {
        waarden = [];
      } else {
        const plek = waarden.findIndex((w) => w.toLowerCase() === waarde.toLowerCase());
        if (plek >= 0) {
          waarden.splice(plek, 1);
        } else {
          waarden.push(waarde);
        }
      }

      event.preventDefault();
      url.searchParams.delete(param);
      url.searchParams.delete('page');
      if (waarden.length > 0) url.searchParams.set(param, waarden.join(','));
      window.location.assign(url.toString());
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-collection-row"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sora-collectie-rij')) {
    class SoraCollectieRij extends HTMLElement {
      connectedCallback() {
        this.baan = this.querySelector('.sora-cr__baan');
        if (!this.baan) return;
        this.bijwerken = this.bijwerken.bind(this);
        this.opScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.bijwerken();
          });
        };
        this.opKlik = (event) => {
          const knop = event.target.closest('.sora-cr__pijl');
          if (!knop || !this.contains(knop)) return;
          const richting = Number(knop.dataset.richting) || 1;
          const rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.baan.scrollBy({ left: richting * this.baan.clientWidth * 0.8, behavior: rustig ? 'auto' : 'smooth' });
        };
        this.opBlokKeuze = (event) => {
          if (event.target && this.baan.contains(event.target)) {
            event.target.scrollIntoView({ block: 'nearest', inline: 'center' });
          }
        };
        this.baan.addEventListener('scroll', this.opScroll, { passive: true });
        this.addEventListener('click', this.opKlik);
        document.addEventListener('shopify:block:select', this.opBlokKeuze);
        this.waarnemer = new ResizeObserver(this.opScroll);
        this.waarnemer.observe(this.baan);
        this.bijwerken();
      }

      disconnectedCallback() {
        if (!this.baan) return;
        this.baan.removeEventListener('scroll', this.opScroll);
        this.removeEventListener('click', this.opKlik);
        document.removeEventListener('shopify:block:select', this.opBlokKeuze);
        if (this.waarnemer) this.waarnemer.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      bijwerken() {
        const b = this.baan;
        const max = b.scrollWidth - b.clientWidth;
        const positie = Math.abs(b.scrollLeft);
        this.toggleAttribute('data-meer-start', max > 1 && positie > 1);
        this.toggleAttribute('data-meer-eind', max > 1 && positie < max - 1);
      }
    }

    customElements.define('sora-collectie-rij', SoraCollectieRij);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-favorieten-pagina"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SLEUTEL = 'sora-favorieten';
    const ATTRIBUUT = 'sora_favorieten';
    const HERLAAD = 'sora-fav-herladen';

    const leesLijst = () => {
      try {
        const waarde = JSON.parse(localStorage.getItem(SLEUTEL) || '[]');
        return Array.isArray(waarde) ? waarde.filter((handle) => typeof handle === 'string') : [];
      } catch (fout) {
        return [];
      }
    };

    const vul = (sjabloon, waarden) =>
      Object.entries(waarden).reduce(
        (tekst, [sleutel, waarde]) => tekst.split('{' + sleutel + '}').join(String(waarde)),
        sjabloon || ''
      );

    const postJson = async (url, body) => {
      const antwoord = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await antwoord.json().catch(() => ({}));
      return { ok: antwoord.ok && !data.status, data };
    };

    let events = null;
    const laadEvents = async () => {
      if (events !== null) return events;
      try {
        events = await import('@shopify/events');
      } catch (fout) {
        events = false;
      }
      return events;
    };

    const init = (root) => {
      if (!root || root.dataset.soraFavKlaar === 'true') return;
      root.dataset.soraFavKlaar = 'true';

      let cfg = {};
      try {
        cfg = JSON.parse(root.querySelector('[data-sora-fav-config]').textContent);
      } catch (fout) {
        return;
      }

      const binnen = root.querySelector('[data-sora-fav-binnen]');
      const laden = root.querySelector('[data-sora-fav-laden]');
      const leeg = root.querySelector('[data-sora-fav-leeg]');
      const ontwerp = root.dataset.ontwerp === 'true';
      let items = [];

      let formatteer;
      try {
        const nf = new Intl.NumberFormat(root.dataset.taal || undefined, {
          style: 'currency',
          currency: root.dataset.valuta || 'EUR',
        });
        formatteer = (centen) => nf.format(centen / 100);
      } catch (fout) {
        formatteer = (centen) => (centen / 100).toFixed(2);
      }

      const melding = () => binnen.querySelector('[data-sora-fav-melding]');
      const toonMelding = (soort, tekst) => {
        const el = melding();
        if (!el) return;
        el.dataset.soort = soort;
        el.textContent = tekst;
      };

      const varOpties = (v) => (Array.isArray(v.options) ? v.options : [v.option1, v.option2, v.option3].filter((o) => o != null));

      const bouwItem = (li) => {
        let varianten = [];
        try {
          varianten = JSON.parse(li.querySelector('[data-sora-fav-varianten]').textContent);
        } catch (fout) {
          varianten = [];
        }
        const selects = Array.from(li.querySelectorAll('.sora-fav-select'));
        const knop = li.querySelector('[data-sora-fav-voegtoe]');
        const prijs = li.querySelector('[data-sora-fav-prijs]');
        const item = { li, handle: li.dataset.handle, knop, variant: null };

        const kies = () => {
          if (!selects.length) return varianten.find((v) => v.available) || varianten[0] || null;
          const gekozen = selects.map((select) => select.value);
          return varianten.find((v) => varOpties(v).every((w, i) => w === gekozen[i])) || null;
        };

        item.toon = () => {
          const v = item.variant;
          if (prijs) {
            prijs.textContent = '';
            if (v) {
              if (v.compare_at_price && v.compare_at_price > v.price) {
                const oud = document.createElement('s');
                oud.textContent = formatteer(v.compare_at_price);
                prijs.appendChild(oud);
              }
              prijs.appendChild(document.createTextNode(formatteer(v.price)));
            }
          }
          if (knop) {
            const beschikbaar = !!(v && v.available);
            knop.disabled = !beschikbaar;
            knop.textContent = beschikbaar ? cfg.knopKaart : cfg.uitverkocht;
          }
        };

        item.variant = kies();
        selects.forEach((select) => {
          select.addEventListener('change', () => {
            item.variant = kies();
            item.toon();
          });
        });
        if (knop) knop.addEventListener('click', () => voegToe([item]));

        item.toonHart = () => {
          li.dataset.favoriet = leesLijst().indexOf(item.handle) !== -1 ? 'true' : 'false';
        };
        item.toon();
        return item;
      };

      const alleKnoppen = () => Array.from(binnen.querySelectorAll('[data-sora-fav-voegtoe], [data-sora-fav-alles-knop]'));

      const toonKnoppen = () => {
        const alles = binnen.querySelector('[data-sora-fav-alles-knop]');
        if (alles) {
          alles.disabled = !items.some((item) => item.li.dataset.favoriet === 'true' && item.variant && item.variant.available);
        }
        items.forEach((item) => {
          if (item.knop) item.knop.disabled = !(item.variant && item.variant.available);
        });
      };

      const voegToe = async (lijst) => {
        const regels = lijst.filter((item) => item.variant && item.variant.available);
        const overgeslagen = lijst.length - regels.length;

        if (!regels.length) {
          toonMelding('fout', vul(cfg.meldingDeels, { aantal: 0, overgeslagen }));
          return;
        }

        const knoppen = alleKnoppen();
        const tekstenVoor = new Map();
        knoppen.forEach((k) => {
          tekstenVoor.set(k, k.textContent);
          k.disabled = true;
          if (k.hasAttribute('data-sora-fav-voegtoe')) k.textContent = cfg.knopBezig;
        });
        toonMelding('', '');

        const ev = await laadEvents();
        let uitgesteld = null;
        if (ev && ev.CartLinesUpdateEvent) {
          try {
            uitgesteld = ev.CartLinesUpdateEvent.createPromise();
            root.dispatchEvent(
              new ev.CartLinesUpdateEvent({
                action: 'add',
                context: 'product',
                lines: regels.map((item) => ({ merchandiseId: String(item.variant.id), quantity: 1 })),
                promise: uitgesteld.promise,
              })
            );
          } catch (fout) {
            uitgesteld = null;
          }
        }

        const sectieIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((c) => c.dataset.sectionId)
          .filter(Boolean)
          .join(',');
        const post = (r) =>
          postJson(root.dataset.cartAddUrl, {
            items: r.map((item) => ({ id: item.variant.id, quantity: 1 })),
            sections: sectieIds || undefined,
          });

        let gelukt = 0;
        let laatsteSecties;
        try {
          const resultaat = await post(regels);
          if (resultaat.ok) {
            gelukt = regels.length;
            laatsteSecties = resultaat.data.sections;
          } else {
            for (const item of regels) {
              const enkel = await post([item]);
              if (enkel.ok) {
                gelukt += 1;
                laatsteSecties = enkel.data.sections;
              }
            }
          }
        } catch (fout) {
          gelukt = 0;
        }

        let winkelwagen = null;
        try {
          const antwoord = await fetch(root.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } });
          winkelwagen = await antwoord.json();
        } catch (fout) {
          winkelwagen = null;
        }

        if (uitgesteld) {
          if (winkelwagen && winkelwagen.items) {
            uitgesteld.resolve({
              cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(winkelwagen),
              detail: {
                items: winkelwagen.items,
                source: 'sora-favorieten-pagina',
                sourceId: root.dataset.sectie,
                itemCount: winkelwagen.item_count,
                sections: laatsteSecties,
                didError: gelukt === 0,
              },
            });
          } else {
            uitgesteld.reject(new Error('Winkelwagen niet opgehaald'));
          }
        }

        knoppen.forEach((k) => {
          k.textContent = tekstenVoor.get(k);
        });
        items.forEach((item) => item.toon());
        toonKnoppen();

        const mislukt = regels.length - gelukt + overgeslagen;
        if (gelukt === 0) {
          toonMelding('fout', cfg.meldingFout);
        } else if (mislukt > 0) {
          toonMelding('succes', vul(cfg.meldingDeels, { aantal: gelukt, overgeslagen: mislukt }));
        } else {
          toonMelding('succes', vul(cfg.meldingSucces, { aantal: gelukt }));
        }

        if (gelukt > 0 && !uitgesteld) {
          window.location.assign(root.dataset.cartUrl);
        }
      };

      const toonLeeg = () => {
        laden.hidden = true;
        binnen.hidden = true;
        leeg.hidden = false;
        root.setAttribute('aria-busy', 'false');
      };

      const toonKaarten = () => {
        items = Array.from(binnen.querySelectorAll('[data-sora-fav-item]')).map(bouwItem);
        if (!items.length) {
          toonLeeg();
          return;
        }
        const alles = binnen.querySelector('[data-sora-fav-alles-knop]');
        if (alles) alles.addEventListener('click', () => voegToe(items.filter((item) => item.li.dataset.favoriet === 'true')));
        laden.hidden = true;
        leeg.hidden = true;
        binnen.hidden = false;
        root.setAttribute('aria-busy', 'false');
        toonKnoppen();
      };

      const wisAttribuut = () => {
        postJson(root.dataset.cartUpdateUrl, { attributes: { [ATTRIBUUT]: '' } }).catch(() => {});
      };

      document.addEventListener('sora:favorieten-gewijzigd', () => {
        if (ontwerp) return;
        items.forEach((item) => item.toonHart());
        toonKnoppen();
      });

      const start = async () => {
        if (ontwerp) {
          toonKaarten();
          return;
        }

        const lijst = leesLijst().slice(-(cfg.max || 20));
        const waarde = lijst.join(',');

        if (!waarde) {
          toonLeeg();
          if (root.dataset.attribuut) wisAttribuut();
          return;
        }

        root.setAttribute('aria-busy', 'true');

        // De server heeft de kaarten al goed gerenderd (herladen of eerder gezet attribuut)
        if (root.dataset.attribuut === waarde && binnen.querySelector('[data-sora-fav-item]')) {
          try {
            sessionStorage.removeItem(HERLAAD);
          } catch (fout) {
            /* geen sessieopslag */
          }
          toonKaarten();
          wisAttribuut();
          return;
        }

        laden.hidden = false;
        binnen.hidden = true;
        leeg.hidden = true;

        try {
          const antwoord = await postJson(root.dataset.cartUpdateUrl, {
            attributes: { [ATTRIBUUT]: waarde },
            sections: root.dataset.sectie,
            sections_url: window.location.pathname,
          });
          const html = antwoord.ok && antwoord.data.sections && antwoord.data.sections[root.dataset.sectie];
          const nieuw = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sora-fav-binnen]');
          if (!nieuw) throw new Error('Sectie niet teruggekomen');
          binnen.innerHTML = nieuw.innerHTML;
          wisAttribuut();
          toonKaarten();
        } catch (fout) {
          // Terugval: het attribuut staat (of we proberen het opnieuw) en de pagina laadt een keer opnieuw
          let alGeprobeerd = false;
          try {
            alGeprobeerd = sessionStorage.getItem(HERLAAD) === '1';
            if (!alGeprobeerd) sessionStorage.setItem(HERLAAD, '1');
          } catch (e) {
            alGeprobeerd = true;
          }
          if (!alGeprobeerd) {
            window.location.reload();
          } else {
            toonLeeg();
          }
        }
      };

      start();
    };

    const initAlles = () => document.querySelectorAll('[data-sora-fav-pagina]').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAlles);
    } else {
      initAlles();
    }
    document.addEventListener('shopify:section:load', initAlles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-flowchart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('sora-flowchart')) return;

    var SVG_NS = 'http://www.w3.org/2000/svg';

    class SoraFlowchart extends HTMLElement {
      connectedCallback() {
        this.veld = this.querySelector('[data-sora-fc-veld]');
        this.raster = this.querySelector('[data-sora-fc-raster]');
        this.svg = this.querySelector('[data-sora-fc-svg]');
        if (!this.veld || !this.raster || !this.svg) return;
        this.kanaal = { boven: 0, rechts: 0, onder: 0, links: 0 };
        this.kanaalBreedte = 0;
        this.plan = this.plan.bind(this);
        this.ro = new ResizeObserver(this.plan);
        this.ro.observe(this.veld);
        this.querySelectorAll('[data-sora-fc-kaart]').forEach((k) => this.ro.observe(k));
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.plan);
        window.addEventListener('load', this.plan, { once: true });
        this.schermlezer();
        this.plan();
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        cancelAnimationFrame(this.raf);
      }

      plan() {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.teken());
      }

      getal(naam, standaard) {
        var w = parseFloat(this.dataset[naam]);
        return isNaN(w) ? standaard : w;
      }

      kaarten() {
        var lijst = Array.from(this.querySelectorAll('[data-sora-fc-kaart]'));
        var perId = new Map();
        lijst.forEach((k) => {
          var id = (k.dataset.soraFcId || '').trim().toLowerCase();
          if (id && !perId.has(id)) perId.set(id, k);
        });
        return { lijst: lijst, perId: perId };
      }

      doelen(kaart) {
        return (kaart.dataset.soraFcNaar || '')
          .split(',')
          .map((d) => d.trim().toLowerCase())
          .filter(Boolean);
      }

      schermlezer() {
        var label = this.dataset.srTekst || '';
        var k = this.kaarten();
        k.lijst.forEach((kaart) => {
          var sr = kaart.querySelector('[data-sora-fc-sr]');
          if (!sr) return;
          var namen = this.doelen(kaart)
            .map((id) => k.perId.get(id))
            .filter((d) => d && d !== kaart)
            .map((d) => {
              var t = d.querySelector('[data-sora-fc-titel]');
              return t ? t.textContent.trim() : d.dataset.soraFcId;
            });
          sr.textContent = namen.length ? (label + ' ' + namen.join(', ')).trim() : '';
        });
      }

      teken() {
        var svg = this.svg;
        while (svg.firstChild) svg.removeChild(svg.firstChild);

        var mobiel = window.matchMedia('(max-width: 749px)').matches;
        if (mobiel && this.dataset.pijlMobiel !== 'true') return;

        var veldRect = this.veld.getBoundingClientRect();
        if (veldRect.width === 0) return;
        if (Math.round(veldRect.width) !== this.kanaalBreedte) {
          this.kanaalBreedte = Math.round(veldRect.width);
          this.kanaal = { boven: 0, rechts: 0, onder: 0, links: 0 };
          this.zetKanaal();
          veldRect = this.veld.getBoundingClientRect();
        }

        var stijl = getComputedStyle(this.raster);
        var gx = parseFloat(stijl.columnGap) || 0;
        var gy = parseFloat(stijl.rowGap) || 0;
        var sx = this.getal('skX', 0);
        var sy = this.getal('skY', 0);
        var afstand = this.getal('pijlAfstand', 8);
        var hoek = this.getal('pijlHoek', 0);
        var dikte = this.getal('pijlDikte', 2);
        var punt = this.getal('pijlPunt', 12);

        var rel = (el) => {
          var r = el.getBoundingClientRect();
          return { l: r.left - veldRect.left, t: r.top - veldRect.top, r: r.right - veldRect.left, b: r.bottom - veldRect.top };
        };
        var rRaster = rel(this.raster);
        var k = this.kaarten();
        var vakken = new Map();
        k.lijst.forEach((kaart) => {
          var v = rel(kaart);
          v.cx = (v.l + v.r) / 2;
          v.cy = (v.t + v.b) / 2;
          v.el = kaart;
          vakken.set(kaart, v);
        });

        var ctx = { gx: gx, gy: gy, sx: sx, sy: sy, raster: rRaster, vakken: vakken };
        var routes = [];
        k.lijst.forEach((kaart) => {
          this.doelen(kaart).forEach((id) => {
            var doel = k.perId.get(id);
            if (!doel || doel === kaart) return;
            var punten = this.route(vakken.get(kaart), vakken.get(doel), ctx);
            if (punten && punten.length > 1) routes.push({ pts: punten, A: vakken.get(kaart), B: vakken.get(doel) });
          });
        });
        this.spreid(routes, ctx);
        this.banen(routes, ctx);
        routes = routes.map((r) => r.pts);

        var nodig = { boven: 0, rechts: 0, onder: 0, links: 0 };
        var marge = punt / 2 + dikte;
        routes.forEach((pts) => {
          pts.forEach((p) => {
            if (p.y < rRaster.t - 1) nodig.boven = Math.max(nodig.boven, rRaster.t - p.y + marge);
            if (p.y > rRaster.b + 1) nodig.onder = Math.max(nodig.onder, p.y - rRaster.b + marge);
            if (p.x > rRaster.r + 1) nodig.rechts = Math.max(nodig.rechts, p.x - rRaster.r + marge);
            if (p.x < rRaster.l - 1) nodig.links = Math.max(nodig.links, rRaster.l - p.x + marge);
          });
        });
        var veranderd = false;
        ['boven', 'rechts', 'onder', 'links'].forEach((kant) => {
          if (nodig[kant] > (this.kanaal[kant] || 0) + 0.5) {
            this.kanaal[kant] = Math.ceil(nodig[kant]);
            veranderd = true;
          }
        });
        if (veranderd) {
          this.zetKanaal();
          this.kanaalBreedte = Math.round(this.veld.getBoundingClientRect().width);
          this.plan();
          return;
        }

        var uid = this.dataset.uid || 'sora-fc';
        var defs = document.createElementNS(SVG_NS, 'defs');
        var marker = document.createElementNS(SVG_NS, 'marker');
        marker.setAttribute('id', uid + '-punt');
        marker.setAttribute('markerUnits', 'userSpaceOnUse');
        marker.setAttribute('markerWidth', punt + dikte * 2);
        marker.setAttribute('markerHeight', punt + dikte * 2);
        marker.setAttribute('viewBox', [-dikte, -dikte, punt + dikte * 2, punt + dikte * 2].join(' '));
        marker.setAttribute('refX', punt);
        marker.setAttribute('refY', punt / 2);
        marker.setAttribute('orient', 'auto');
        marker.setAttribute('overflow', 'visible');
        var vorm = document.createElementNS(SVG_NS, 'path');
        if (this.dataset.pijlVorm === 'gevuld') {
          vorm.setAttribute('d', 'M0 0 L' + punt + ' ' + punt / 2 + ' L0 ' + punt + ' Z');
          vorm.setAttribute('fill', 'currentColor');
        } else {
          vorm.setAttribute('d', 'M0 0 L' + punt + ' ' + punt / 2 + ' L0 ' + punt);
          vorm.setAttribute('fill', 'none');
          vorm.setAttribute('stroke', 'currentColor');
          vorm.setAttribute('stroke-width', dikte);
          vorm.setAttribute('stroke-linecap', 'round');
          vorm.setAttribute('stroke-linejoin', 'round');
        }
        marker.appendChild(vorm);
        defs.appendChild(marker);
        svg.appendChild(defs);

        var streep = '';
        if (this.dataset.pijlLijn === 'gestreept') streep = dikte * 4 + ' ' + dikte * 3;
        if (this.dataset.pijlLijn === 'gestippeld') streep = '0 ' + dikte * 2.5;
        routes.forEach((pts) => {
          pts = this.kort(pts, afstand, afstand);
          if (!pts) return;
          var pad = document.createElementNS(SVG_NS, 'path');
          pad.setAttribute('d', this.padTekst(pts, hoek));
          pad.setAttribute('fill', 'none');
          pad.setAttribute('stroke', 'currentColor');
          pad.setAttribute('stroke-width', dikte);
          pad.setAttribute('stroke-linecap', this.dataset.pijlLijn === 'gestippeld' ? 'round' : 'butt');
          pad.setAttribute('stroke-linejoin', 'round');
          if (streep) pad.setAttribute('stroke-dasharray', streep);
          pad.setAttribute('marker-end', 'url(#' + uid + '-punt)');
          svg.appendChild(pad);
        });
      }

      /* Kant van de kaart waar een lijnstuk vertrekt (begin) of aankomt (eind) */
      kant(p, q, begin) {
        if (Math.abs(p.x - q.x) < 0.5) {
          var omlaag = q.y > p.y;
          return begin ? (omlaag ? 'b' : 't') : (omlaag ? 't' : 'b');
        }
        var rechts = q.x > p.x;
        return begin ? (rechts ? 'r' : 'l') : (rechts ? 'l' : 'r');
      }

      /* Meerdere pijlen op dezelfde kant van een kaart naast elkaar zetten */
      spreid(routes, c) {
        var groepen = new Map();
        routes.forEach((r) => {
          var n = r.pts.length;
          var kb = this.kant(r.pts[0], r.pts[1], true);
          var ke = this.kant(r.pts[n - 2], r.pts[n - 1], false);
          r.verschuif = { begin: 0, eind: 0 };
          [[r.A, kb, 'begin', r.B], [r.B, ke, 'eind', r.A]].forEach(([v, k, eind, ander]) => {
            /* Kaarten die dezelfde tussenruimte delen (onder de ene, boven de andere) vormen één groep */
            var liggend = k === 't' || k === 'b';
            var sleutel = liggend
              ? 'h|' + Math.round(this.tussen(v, k, c)) + '|' + Math.round(v.l)
              : 'v|' + Math.round(this.tussen(v, k, c)) + '|' + Math.round(v.t);
            if (!groepen.has(sleutel)) groepen.set(sleutel, { v: v, k: k, items: [] });
            groepen.get(sleutel).items.push({ r: r, eind: eind, ander: ander });
          });
        });
        groepen.forEach((g) => {
          var n = g.items.length;
          if (n < 2) return;
          var liggend = g.k === 't' || g.k === 'b';
          var lengte = liggend ? g.v.r - g.v.l : g.v.b - g.v.t;
          var stap = Math.min(28, lengte / (n + 1));
          g.items.sort((a, b) => (liggend ? a.ander.cx - b.ander.cx : a.ander.cy - b.ander.cy));
          g.items.forEach((it, i) => {
            it.r.verschuif[it.eind] = (i - (n - 1) / 2) * stap;
          });
        });
        routes.forEach((r) => {
          var pts = r.pts;
          var n = pts.length;
          var as = (p, q) => (Math.abs(p.x - q.x) < 0.5 ? 'x' : 'y');
          if (n === 2) {
            var o = (r.verschuif.begin + r.verschuif.eind) / 2;
            var a = as(pts[0], pts[1]);
            pts[0][a] += o;
            pts[1][a] += o;
            return;
          }
          var ab = as(pts[0], pts[1]);
          pts[0][ab] += r.verschuif.begin;
          pts[1][ab] += r.verschuif.begin;
          var ae = as(pts[n - 2], pts[n - 1]);
          pts[n - 1][ae] += r.verschuif.eind;
          pts[n - 2][ae] += r.verschuif.eind;
        });
      }

      /* Lijnstukken in dezelfde tussenruimte die elkaar overlappen elk een eigen baan geven */
      banen(routes, c) {
        ['y', 'x'].forEach((as) => {
          var ander = as === 'y' ? 'x' : 'y';
          var emmers = new Map();
          routes.forEach((r) => {
            var pts = r.pts;
            for (var i = 1; i < pts.length - 2; i++) {
              var p = pts[i];
              var q = pts[i + 1];
              if (Math.abs(p[as] - q[as]) > 0.5) continue;
              var sleutel = Math.round(p[as] / 4);
              if (!emmers.has(sleutel)) emmers.set(sleutel, []);
              emmers.get(sleutel).push({ p: p, q: q, van: Math.min(p[ander], q[ander]), tot: Math.max(p[ander], q[ander]) });
            }
          });
          var ruimte = as === 'y' ? c.gy - Math.abs(c.sy) : c.gx - Math.abs(c.sx);
          emmers.forEach((stukken) => {
            if (stukken.length < 2) return;
            stukken.sort((a, b) => a.van - b.van);
            var banen = [];
            stukken.forEach((st) => {
              var b = banen.findIndex((eind) => eind < st.van - 6);
              if (b === -1) {
                banen.push(st.tot);
                st.baan = banen.length - 1;
              } else {
                banen[b] = st.tot;
                st.baan = b;
              }
            });
            var n = banen.length;
            if (n < 2) return;
            var stap = Math.min(12, ruimte / (n + 1));
            stukken.forEach((st) => {
              var o = (st.baan - (n - 1) / 2) * stap;
              st.p[as] += o;
              st.q[as] += o;
            });
          });
        });
      }

      zetKanaal() {
        ['boven', 'rechts', 'onder', 'links'].forEach((kant) => {
          this.veld.style.setProperty('--sora-fc-kanaal-' + kant, (this.kanaal[kant] || 0) + 'px');
        });
      }

      /* Rand van een kaart, inclusief het verschoven vlak bij de scheve look */
      rand(v, kant, c) {
        if (kant === 'r') return v.r + Math.max(0, c.sx);
        if (kant === 'l') return v.l - Math.max(0, -c.sx);
        if (kant === 'b') return v.b + Math.max(0, c.sy);
        return v.t - Math.max(0, -c.sy);
      }

      /* Midden van de tussenruimte onder, boven, rechts of links van een kaart */
      tussen(v, kant, c) {
        if (kant === 'b') return v.b + (c.gy + c.sy) / 2;
        if (kant === 't') return v.t - (c.gy - c.sy) / 2;
        if (kant === 'r') return v.r + (c.gx + c.sx) / 2;
        return v.l - (c.gx - c.sx) / 2;
      }

      pijlY(A, B) {
        var boven = Math.max(A.t, B.t);
        var onder = Math.min(A.b, B.b);
        var midden = (boven + onder) / 2;
        if (this.dataset.pijlHoogte === 'titel') {
          var rij = A.el.querySelector('[data-sora-fc-titelrij]');
          if (rij) {
            var r = rij.getBoundingClientRect();
            var vr = this.veld.getBoundingClientRect();
            var y = (r.top + r.bottom) / 2 - vr.top;
            if (y > boven + 4 && y < onder - 4) return y;
          }
        }
        return midden;
      }

      route(A, B, c) {
        var vOverlap = Math.min(A.b, B.b) - Math.max(A.t, B.t);
        var hOverlap = Math.min(A.r, B.r) - Math.max(A.l, B.l);
        var kandidaten = [];
        var buitenR = c.raster.r + (c.gx + c.sx) / 2 + Math.max(0, c.sx);
        var buitenL = c.raster.l - (c.gx - c.sx) / 2 - Math.max(0, -c.sx);

        if (vOverlap > 16) {
          var y = this.pijlY(A, B);
          var naarRechts = B.cx > A.cx;
          kandidaten.push([
            { x: naarRechts ? this.rand(A, 'r', c) : this.rand(A, 'l', c), y: y },
            { x: naarRechts ? this.rand(B, 'l', c) : this.rand(B, 'r', c), y: y }
          ]);
          var yo = Math.max(this.tussen(A, 'b', c), this.tussen(B, 'b', c));
          kandidaten.push([
            { x: A.cx, y: this.rand(A, 'b', c) }, { x: A.cx, y: yo }, { x: B.cx, y: yo }, { x: B.cx, y: this.rand(B, 'b', c) }
          ]);
          var yb = Math.min(this.tussen(A, 't', c), this.tussen(B, 't', c));
          kandidaten.push([
            { x: A.cx, y: this.rand(A, 't', c) }, { x: A.cx, y: yb }, { x: B.cx, y: yb }, { x: B.cx, y: this.rand(B, 't', c) }
          ]);
        } else {
          var omlaag = B.cy > A.cy;
          var uitKant = omlaag ? 'b' : 't';
          var inKant = omlaag ? 't' : 'b';
          var y1 = this.rand(A, uitKant, c);
          var y2 = this.rand(B, inKant, c);
          var ym1 = this.tussen(A, uitKant, c);
          var ym2 = this.tussen(B, inKant, c);
          if (hOverlap > 16) {
            var xo = (Math.max(A.l, B.l) + Math.min(A.r, B.r)) / 2;
            kandidaten.push([{ x: xo, y: y1 }, { x: xo, y: y2 }]);
          }
          kandidaten.push([{ x: A.cx, y: y1 }, { x: A.cx, y: ym1 }, { x: B.cx, y: ym1 }, { x: B.cx, y: y2 }]);
          kandidaten.push([{ x: A.cx, y: y1 }, { x: A.cx, y: ym2 }, { x: B.cx, y: ym2 }, { x: B.cx, y: y2 }]);
          var rechts = B.cx >= A.cx;
          var kolomA = rechts ? this.tussen(A, 'r', c) : this.tussen(A, 'l', c);
          var kolomB = rechts ? this.tussen(B, 'l', c) : this.tussen(B, 'r', c);
          [kolomA, kolomB, buitenR, buitenL].forEach((xc) => {
            kandidaten.push([
              { x: A.cx, y: y1 }, { x: A.cx, y: ym1 }, { x: xc, y: ym1 }, { x: xc, y: ym2 }, { x: B.cx, y: ym2 }, { x: B.cx, y: y2 }
            ]);
          });
        }

        var vrij = kandidaten.map((pts) => this.schoon(pts)).filter((pts) => !this.botst(pts, A, B, c));
        var binnen = vrij.filter((pts) =>
          pts.every((p) => p.x >= c.raster.l - 1 && p.x <= c.raster.r + 1 && p.y >= c.raster.t - 1 && p.y <= c.raster.b + 1)
        );
        if (binnen.length) return binnen[0];
        if (vrij.length) return vrij[0];
        return this.schoon(kandidaten[kandidaten.length - 1]);
      }

      /* Dubbele punten en punten op één lijn weghalen */
      schoon(pts) {
        var uit = [];
        pts.forEach((p) => {
          var l = uit[uit.length - 1];
          if (l && Math.abs(l.x - p.x) < 0.5 && Math.abs(l.y - p.y) < 0.5) return;
          uit.push({ x: p.x, y: p.y });
        });
        for (var i = uit.length - 2; i > 0; i--) {
          var a = uit[i - 1];
          var b = uit[i];
          var d = uit[i + 1];
          if ((Math.abs(a.x - b.x) < 0.5 && Math.abs(b.x - d.x) < 0.5) || (Math.abs(a.y - b.y) < 0.5 && Math.abs(b.y - d.y) < 0.5)) {
            uit.splice(i, 1);
          }
        }
        return uit;
      }

      botst(pts, A, B, c) {
        for (var [kaart, v] of c.vakken) {
          var l = Math.min(v.l, v.l + c.sx) + 1;
          var r = Math.max(v.r, v.r + c.sx) - 1;
          var t = Math.min(v.t, v.t + c.sy) + 1;
          var b = Math.max(v.b, v.b + c.sy) - 1;
          for (var i = 0; i < pts.length - 1; i++) {
            var p = pts[i];
            var q = pts[i + 1];
            var eigen = v === A || v === B;
            if (eigen) {
              /* Alleen het middenstuk mag niet door de eigen kaarten lopen */
              if (i === 0 || i === pts.length - 2) continue;
            }
            var sl = Math.min(p.x, q.x);
            var sr = Math.max(p.x, q.x);
            var st = Math.min(p.y, q.y);
            var sb = Math.max(p.y, q.y);
            if (sr > l && sl < r && sb > t && st < b) return true;
          }
        }
        return false;
      }

      /* Begin en eind inkorten zodat er ruimte blijft tussen pijl en kaart */
      kort(pts, begin, eind) {
        pts = pts.map((p) => ({ x: p.x, y: p.y }));
        var n = pts.length;
        var schuif = (p, naar, af) => {
          var dx = naar.x - p.x;
          var dy = naar.y - p.y;
          var len = Math.hypot(dx, dy);
          if (len <= af + 2) return false;
          p.x += (dx / len) * af;
          p.y += (dy / len) * af;
          return true;
        };
        if (!schuif(pts[0], pts[1], begin)) return n > 2 ? pts : null;
        if (!schuif(pts[n - 1], pts[n - 2], eind)) return n > 2 ? pts : null;
        return pts;
      }

      padTekst(pts, hoek) {
        var d = 'M' + pts[0].x + ' ' + pts[0].y;
        for (var i = 1; i < pts.length - 1; i++) {
          var a = pts[i - 1];
          var b = pts[i];
          var e = pts[i + 1];
          var r = Math.min(hoek, Math.hypot(b.x - a.x, b.y - a.y) / 2, Math.hypot(e.x - b.x, e.y - b.y) / 2);
          if (r <= 0.5) {
            d += ' L' + b.x + ' ' + b.y;
            continue;
          }
          var l1 = Math.hypot(b.x - a.x, b.y - a.y);
          var l2 = Math.hypot(e.x - b.x, e.y - b.y);
          var p1 = { x: b.x - ((b.x - a.x) / l1) * r, y: b.y - ((b.y - a.y) / l1) * r };
          var p2 = { x: b.x + ((e.x - b.x) / l2) * r, y: b.y + ((e.y - b.y) / l2) * r };
          d += ' L' + p1.x + ' ' + p1.y + ' Q' + b.x + ' ' + b.y + ' ' + p2.x + ' ' + p2.y;
        }
        var z = pts[pts.length - 1];
        return d + ' L' + z.x + ' ' + z.y;
      }
    }

    customElements.define('sora-flowchart', SoraFlowchart);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const breed = window.matchMedia('(min-width: 750px)');
    const rustig = window.matchMedia('(prefers-reduced-motion: reduce)');

    function synchroniseer(wortel) {
      wortel.querySelectorAll('video[data-sora-hero-video]').forEach((video) => {
        video.muted = true;
        const zichtbaar = video.offsetParent !== null;
        if (zichtbaar && !rustig.matches) {
          const belofte = video.play();
          if (belofte && belofte.catch) belofte.catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    const start = () => synchroniseer(document);
    start();
    breed.addEventListener('change', start);
    rustig.addEventListener('change', start);
    document.addEventListener('shopify:section:load', (gebeurtenis) => synchroniseer(gebeurtenis.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-informatieblok"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.soraInformatieblokFormulier) return;
    window.soraInformatieblokFormulier = true;

    const vergrendel = (aan) => document.documentElement.classList.toggle('sora-ib-lock', aan);
    const open = (dialoog) => {
      if (!dialoog || dialoog.open) return;
      if (typeof dialoog.showModal === 'function') dialoog.showModal();
      else dialoog.setAttribute('open', '');
      vergrendel(true);
      dialoog.addEventListener('close', () => vergrendel(false), { once: true });
    };
    const sluit = (dialoog) => {
      if (!dialoog) return;
      if (typeof dialoog.close === 'function') dialoog.close();
      else {
        dialoog.removeAttribute('open');
        vergrendel(false);
      }
    };

    document.addEventListener('click', (event) => {
      const knop = event.target.closest('[data-sora-ib-open]');
      if (knop) {
        const dialoog = document.getElementById(knop.dataset.soraIbOpen);
        if (!dialoog) return;
        event.preventDefault();
        const veld = dialoog.querySelector('[data-sora-ib-onderwerp]');
        if (veld) veld.value = knop.dataset.onderwerp || '';
        dialoog.classList.remove('sora-ib__dialoog--klaar');
        dialoog.querySelectorAll('[data-sora-ib-ok], [data-sora-ib-fout]').forEach((el) => { el.hidden = true; });
        open(dialoog);
        return;
      }
      if (event.target.closest('[data-sora-ib-sluit]')) {
        sluit(event.target.closest('dialog'));
        return;
      }
      if (event.target.matches('dialog.sora-ib__dialoog')) sluit(event.target);
    });

    // Na verzenden komt de pagina terug met #<formulier-id> in de adresbalk.
    // Alleen het formulier met dat id toont de melding; andere contactformulieren op de pagina niet.
    const toonMelding = () => {
      const hash = decodeURIComponent(window.location.hash.slice(1));
      if (!hash) return;
      document.querySelectorAll('dialog.sora-ib__dialoog').forEach((dialoog) => {
        if (dialoog.dataset.formId !== hash) return;
        const ok = dialoog.querySelector('[data-sora-ib-ok]');
        const fout = dialoog.querySelector('[data-sora-ib-fout]');
        if (ok) {
          ok.hidden = false;
          dialoog.classList.add('sora-ib__dialoog--klaar');
          open(dialoog);
        } else if (fout) {
          fout.hidden = false;
          open(dialoog);
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', toonMelding);
    else toonMelding();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-koptekst"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.soraKoptekstActief) return;
    window.soraKoptekstActief = true;

    const sluitPopups = (behalve) => {
      document.querySelectorAll('[data-sora-kt-popup]').forEach((popup) => {
        if (popup === behalve) return;
        const knop = popup.querySelector('[data-sora-kt-popupknop]');
        const paneel = popup.querySelector('.sora-koptekst__popup');
        if (!knop || !paneel || paneel.hidden) return;
        paneel.hidden = true;
        knop.setAttribute('aria-expanded', 'false');
      });
    };

    const zetPaneel = (knop, open) => {
      const paneel = document.getElementById(knop.getAttribute('aria-controls'));
      if (!paneel) return;
      paneel.hidden = !open;
      knop.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    const sluitPanelen = () => {
      document.querySelectorAll('[data-sora-kt-paneelknop][aria-expanded="true"]').forEach((knop) => zetPaneel(knop, false));
    };

    document.addEventListener('click', (event) => {
      const doel = event.target instanceof Element ? event.target : null;
      if (!doel) return;

      const paneelknop = doel.closest('[data-sora-kt-paneelknop]');
      if (paneelknop) {
        zetPaneel(paneelknop, paneelknop.getAttribute('aria-expanded') !== 'true');
        return;
      }

      const popupknop = doel.closest('[data-sora-kt-popupknop]');
      if (popupknop) {
        const popup = popupknop.closest('[data-sora-kt-popup]');
        const paneel = popup && popup.querySelector('.sora-koptekst__popup');
        if (!paneel) return;
        const open = paneel.hidden;
        sluitPopups(popup);
        paneel.hidden = !open;
        popupknop.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }

      if (!doel.closest('[data-sora-kt-popup]')) sluitPopups(null);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openPopup = document.querySelector('[data-sora-kt-popupknop][aria-expanded="true"]');
      const openPaneel = document.querySelector('[data-sora-kt-paneelknop][aria-expanded="true"]');
      sluitPopups(null);
      sluitPanelen();
      const terug = openPopup || openPaneel;
      if (terug instanceof HTMLElement) terug.focus();
    });

    document.addEventListener('focusin', (event) => {
      const doel = event.target instanceof Element ? event.target : null;
      if (doel && !doel.closest('[data-sora-kt-popup]')) sluitPopups(null);
    });

    window.matchMedia('(min-width: 750px)').addEventListener('change', (e) => {
      if (e.matches) sluitPanelen();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-lookbook"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sora-lookbook')) return;

    const routes = () => {
      const r = (window.Theme && window.Theme.routes) || {};
      const winkelwagen = r.cart_url || '/cart';
      return { toevoegen: r.cart_add_url || '/cart/add.js', winkelwagen, json: winkelwagen + '.js' };
    };

    let events = null;
    const laadEvents = async () => {
      if (events !== null) return events;
      try {
        events = await import('@shopify/events');
      } catch (fout) {
        events = false;
      }
      return events;
    };

    /* Voegt een of meer varianten in een keer toe en laat Horizon (winkelwagenlade, teller) meelopen via de cartevents. */
    const voegToe = async (regels, bron) => {
      const r = routes();
      const ev = await laadEvents();
      let uitgesteld = null;
      if (ev && ev.CartLinesUpdateEvent) {
        try {
          uitgesteld = ev.CartLinesUpdateEvent.createPromise();
          bron.dispatchEvent(
            new ev.CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: regels.map((regel) => ({ merchandiseId: String(regel.id), quantity: 1 })),
              promise: uitgesteld.promise,
            })
          );
        } catch (fout) {
          uitgesteld = null;
        }
      }

      const sectieIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((c) => c.dataset.sectionId)
        .filter(Boolean)
        .join(',');

      let gelukt = false;
      let secties;
      try {
        const antwoord = await fetch(r.toevoegen, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: regels.map((regel) => ({ id: Number(regel.id), quantity: 1 })),
            sections: sectieIds || undefined,
          }),
        });
        const data = await antwoord.json().catch(() => ({}));
        gelukt = antwoord.ok && !data.status;
        secties = data.sections;
      } catch (fout) {
        gelukt = false;
      }

      if (uitgesteld) {
        let wagen = null;
        try {
          const antwoord = await fetch(r.json, { headers: { Accept: 'application/json' } });
          wagen = await antwoord.json();
        } catch (fout) {
          wagen = null;
        }
        if (wagen && wagen.items) {
          uitgesteld.resolve({
            cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(wagen),
            detail: {
              items: wagen.items,
              source: 'sora-lookbook',
              sourceId: bron.id || '',
              itemCount: wagen.item_count,
              sections: secties,
              didError: !gelukt,
            },
          });
        } else {
          uitgesteld.reject(new Error('Winkelwagen niet opgehaald'));
        }
      } else if (gelukt) {
        window.location.assign(r.winkelwagen);
      }
      return gelukt;
    };

    const maakPrijs = (doel, variant, kortingSjabloon, voorvoegsel) => {
      doel.textContent = '';
      const nu = document.createElement('span');
      nu.className = voorvoegsel + '-nu';
      nu.textContent = variant.prijs;
      doel.appendChild(nu);
      if (variant.verprijs) {
        const oud = document.createElement('s');
        oud.className = voorvoegsel + '-oud';
        oud.textContent = variant.verprijs;
        doel.appendChild(oud);
        if (kortingSjabloon && variant.verprijsCent > variant.prijsCent) {
          const procent = Math.max(1, Math.round(((variant.verprijsCent - variant.prijsCent) * 100) / variant.verprijsCent));
          const badge = document.createElement('span');
          badge.className = 'sora-lb-popup__korting';
          badge.textContent = kortingSjabloon.split('{percentage}').join(String(procent));
          doel.appendChild(badge);
        }
      }
    };

    /* 'Kies een {optie}' + 'Maat' = 'Kies een maat' (optienaam klein, behalve aan het begin) */
    const optieLabel = (sjabloon, naam) => {
      const plek = (sjabloon || '').indexOf('{optie}');
      if (plek === -1) return naam;
      return sjabloon.split('{optie}').join(plek > 0 ? naam.toLowerCase() : naam);
    };

    /* Pop-up: een voor de hele pagina. Eerst een product (knop in de rij) of alle producten zonder gekozen maat ('alles toevoegen'). */
    const Popup = {
      dialog: null,
      host: null,
      items: [],
      extra: [],
      multi: false,
      trigger: null,

      maak() {
        if (this.dialog) return;
        const d = document.createElement('dialog');
        d.className = 'sora-lb-popup';
        d.innerHTML =
          '<div class="sora-lb-popup__binnen">' +
          '<button type="button" class="sora-lb-popup__sluit" data-sluit><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
          '<p class="sora-lb-popup__kop" hidden></p>' +
          '<div class="sora-lb-popup__items"></div>' +
          '<p class="sora-lb-popup__fout" role="status" aria-live="polite"></p>' +
          '<button type="button" class="sora-lb-popup__knop" data-voegtoe></button>' +
          '</div>';

        d.addEventListener('click', (e) => {
          if (e.target === d || e.target.closest('[data-sluit]')) {
            d.close();
            return;
          }
          const waarde = e.target.closest('[data-popup-waarde]');
          if (waarde && !waarde.disabled) {
            this.kies(Number(waarde.dataset.item), Number(waarde.dataset.optie), waarde.dataset.popupWaarde);
            return;
          }
          if (e.target.closest('[data-voegtoe]')) this.toevoegen();
        });
        d.addEventListener('close', () => {
          if (this.trigger && this.trigger.isConnected) this.trigger.focus();
        });
        document.body.appendChild(d);
        this.dialog = d;
      },

      past(item, v, negeer) {
        return item.keuze.every((k, j) => j === negeer || k === null || v.opties[j] === k);
      },

      open(host, rijen, extra, multi, trigger) {
        this.maak();
        this.host = host;
        this.extra = extra;
        this.multi = multi;
        this.trigger = trigger;
        const d = this.dialog;
        d.setAttribute('style', host.dataset.popupStijl || '');
        d.setAttribute('aria-label', multi ? host.tekst.allesKop || host.tekst.allesKnop || '' : rijen[0].sora.data.titel);
        d.querySelector('[data-sluit]').setAttribute('aria-label', host.tekst.sluiten || '');
        d.querySelector('.sora-lb-popup__fout').textContent = '';
        const kop = d.querySelector('.sora-lb-popup__kop');
        kop.textContent = multi ? host.tekst.allesKop || '' : '';
        kop.hidden = !(multi && host.tekst.allesKop);

        this.items = rijen.map((rij) => {
          const item = { rij, data: rij.sora.data, keuze: rij.sora.data.opties.map(() => null) };
          if (rij.sora.keuze !== null) item.keuze[0] = rij.sora.keuze;
          item.data.opties.forEach((optie, i) => {
            if (item.keuze[i] !== null) return;
            const mogelijk = this.waarden(item, i);
            if (mogelijk.length === 1) item.keuze[i] = mogelijk[0].naam;
          });
          return item;
        });

        this.teken();
        if (!d.open) d.showModal();
      },

      waarden(item, i) {
        return item.data.opties[i].waarden.filter((w) => item.data.varianten.some((v) => v.beschikbaar && v.opties[i] === w.naam));
      },

      kies(n, i, naam) {
        const item = this.items[n];
        item.keuze[i] = item.keuze[i] === naam ? null : naam;
        item.data.opties.forEach((optie, j) => {
          if (j === i || item.keuze[j] === null) return;
          const kan = item.data.varianten.some((v) => v.beschikbaar && this.past(item, v, -1));
          if (!kan) item.keuze[j] = null;
        });
        this.dialog.querySelector('.sora-lb-popup__fout').textContent = '';
        this.teken();
      },

      variant(item) {
        if (item.keuze.some((k) => k === null)) return null;
        return item.data.varianten.find((v) => this.past(item, v, -1)) || null;
      },

      teken() {
        const d = this.dialog;
        const lijst = d.querySelector('.sora-lb-popup__items');
        const tekst = this.host.tekst;
        lijst.textContent = '';

        this.items.forEach((item, n) => {
          const data = item.data;
          const blok = document.createElement('section');
          blok.className = 'sora-lb-popup__item';

          const product = document.createElement('div');
          product.className = 'sora-lb-popup__product';
          const beeld = document.createElement('img');
          beeld.className = 'sora-lb-popup__beeld';
          beeld.alt = '';
          const tekstvak = document.createElement('div');
          const titel = document.createElement('p');
          titel.className = 'sora-lb-popup__titel';
          titel.textContent = data.titel;
          const prijs = document.createElement('p');
          prijs.className = 'sora-lb-popup__prijs';
          tekstvak.append(titel, prijs);
          product.append(beeld, tekstvak);

          const v = this.variant(item);
          const voorbeeld = v || data.varianten.find((x) => x.beschikbaar && this.past(item, x, -1)) || data.varianten[0];
          if (voorbeeld) maakPrijs(prijs, voorbeeld, tekst.korting, 'sora-lb-popup__prijs');
          const bron = (voorbeeld && voorbeeld.beeld) || data.beeld;
          if (bron) beeld.src = bron;
          else beeld.hidden = true;

          const opties = document.createElement('div');
          opties.className = 'sora-lb-popup__opties';
          data.opties.forEach((optie, i) => {
            const groep = document.createElement('div');
            groep.setAttribute('role', 'group');
            groep.setAttribute('aria-label', optie.naam);
            const naam = document.createElement('p');
            naam.className = 'sora-lb-popup__naam';
            naam.textContent = optieLabel(tekst.optie, optie.naam) + (item.keuze[i] ? ': ' : '');
            if (item.keuze[i]) {
              const gekozen = document.createElement('span');
              gekozen.textContent = item.keuze[i];
              naam.appendChild(gekozen);
            }
            const rij = document.createElement('div');
            rij.className = 'sora-lb-popup__rij';

            this.waarden(item, i).forEach((w) => {
              const knop = document.createElement('button');
              knop.type = 'button';
              knop.className = 'sora-lb-popup__waarde';
              knop.dataset.item = String(n);
              knop.dataset.optie = String(i);
              knop.dataset.popupWaarde = w.naam;
              knop.setAttribute('aria-pressed', item.keuze[i] === w.naam ? 'true' : 'false');
              /* Beschikbaarheid volgt de opties ervoor (zoals op de productpagina): een andere kleur kiezen kan altijd, een maat die dan niet past vervalt */
              const kan = data.varianten.some(
                (x) => x.beschikbaar && x.opties[i] === w.naam && item.keuze.every((k, j) => j >= i || k === null || x.opties[j] === k)
              );
              knop.disabled = !kan;
              if (optie.type === 'bolletjes' && (w.beeld || w.kleur)) {
                knop.classList.add('sora-lb-popup__waarde--bol');
                knop.setAttribute('aria-label', w.naam);
                knop.title = w.naam;
                if (w.beeld) knop.style.backgroundImage = 'url("' + w.beeld + '")';
                else knop.style.backgroundColor = w.kleur;
              } else {
                knop.textContent = w.naam;
              }
              rij.appendChild(knop);
            });

            groep.append(naam, rij);
            opties.appendChild(groep);
          });

          blok.append(product, opties);
          lijst.appendChild(blok);
        });

        const knop = d.querySelector('[data-voegtoe]');
        knop.textContent = this.multi ? tekst.allesKnop || tekst.knop : tekst.knop;
        knop.disabled = !this.items.every((item) => {
          const v = this.variant(item);
          return v && v.beschikbaar;
        });
      },

      async toevoegen() {
        const regels = this.items.map((item) => this.variant(item));
        if (regels.some((v) => !v || !v.beschikbaar)) return;
        const knop = this.dialog.querySelector('[data-voegtoe]');
        knop.disabled = true;
        knop.textContent = this.host.tekst.bezig;
        const gelukt = await voegToe(regels.concat(this.extra), this.trigger || this.host);
        if (gelukt) {
          this.items.forEach((item) => {
            if (item.rij.isConnected && item.rij.sora.keuze !== item.keuze[0]) this.host.kiesRij(item.rij, item.keuze[0]);
          });
          this.dialog.close();
          this.host.toonKlaar(this.trigger, true);
        } else {
          this.dialog.querySelector('.sora-lb-popup__fout').textContent = this.host.tekst.fout;
          this.teken();
        }
      },
    };

    class SoraLookbook extends HTMLElement {
      connectedCallback() {
        this.melding = this.querySelector('.sora-lb__melding');
        try {
          this.tekst = JSON.parse(this.dataset.tekst || '{}');
        } catch (fout) {
          this.tekst = {};
        }
        this.addEventListener('click', this.opKlik);
        this.addEventListener('mouseover', this.opAanwijzen);
        this.addEventListener('mouseout', this.opAanwijzen);
        this.synchroniseer();
        const lijst = this.querySelector('.sora-lb__lijst');
        if (lijst) {
          this.waarnemer = new MutationObserver(() => this.synchroniseer());
          this.waarnemer.observe(lijst, { childList: true });
        }
      }

      disconnectedCallback() {
        this.waarnemer?.disconnect();
        this.removeEventListener('click', this.opKlik);
        this.removeEventListener('mouseover', this.opAanwijzen);
        this.removeEventListener('mouseout', this.opAanwijzen);
      }

      synchroniseer() {
        this.zetStippen();
        const rijen = Array.from(this.querySelectorAll('[data-sora-lb-rij]'));
        rijen.forEach((rij) => this.rijStatus(rij));
        const alles = this.querySelector('[data-sora-lb-alles]');
        if (alles) alles.hidden = !rijen.some((rij) => rij.sora && rij.sora.data && rij.dataset.beschikbaar === 'true');
      }

      /* Elk itemblok levert een rij (li) en een stip in de lijst; de stippen gaan in volgorde van de rijen op de foto. */
      zetStippen() {
        const lijst = this.querySelector('.sora-lb__lijst');
        const foto = this.querySelector('.sora-lb__stippen');
        if (!lijst || !foto) return;
        const nieuw = new Map();
        lijst.querySelectorAll(':scope > .sora-lb__stip').forEach((stip) => nieuw.set(stip.dataset.soraLbDoel, stip));
        const bestaand = new Map();
        foto.querySelectorAll('.sora-lb__stip').forEach((stip) => bestaand.set(stip.dataset.soraLbDoel, stip));
        lijst.querySelectorAll(':scope > [data-sora-lb-rij]').forEach((rij) => {
          const id = rij.dataset.soraLbRij;
          const stip = nieuw.get(id) || bestaand.get(id);
          if (!stip) return;
          if (nieuw.has(id) && bestaand.has(id) && bestaand.get(id) !== stip) bestaand.get(id).remove();
          foto.appendChild(stip);
          bestaand.delete(id);
        });
        bestaand.forEach((stip) => stip.remove());
      }

      /* Gegevens en keuze per rij; de rij bewaart zijn eigen status */
      rijStatus(rij) {
        if (rij.sora) return rij.sora;
        const bron = rij.querySelector('[data-sora-lb-data]');
        let data = null;
        try {
          data = bron ? JSON.parse(bron.textContent) : null;
        } catch (fout) {
          data = null;
        }
        const prijs = rij.querySelector('[data-sora-lb-prijs]');
        rij.sora = { data, keuze: null, prijsOrigineel: prijs ? prijs.innerHTML : '' };
        /* Maar een variant op voorraad (bij meerdere varianten): die alvast kiezen */
        if (data && data.varianten.length > 1) {
          const op = data.varianten.filter((v) => v.beschikbaar);
          if (op.length === 1) this.kiesRij(rij, op[0].opties[0]);
        }
        return rij.sora;
      }

      kandidaten(rij, naam) {
        const data = rij.sora && rij.sora.data;
        if (!data || naam === null) return [];
        return data.varianten.filter((v) => v.beschikbaar && v.opties[0] === naam);
      }

      vasteVariant(rij) {
        const st = this.rijStatus(rij);
        const data = st.data;
        if (!data) return null;
        if (data.varianten.length === 1) return data.varianten[0];
        if (st.keuze === null) return null;
        const kandidaten = this.kandidaten(rij, st.keuze);
        if (data.opties.length === 1 || kandidaten.length === 1) return kandidaten[0] || null;
        return null;
      }

      kiesRij(rij, naam) {
        const st = this.rijStatus(rij);
        st.keuze = naam;
        rij.querySelectorAll('[data-sora-lb-waarde]').forEach((knop) => {
          knop.setAttribute('aria-pressed', knop.dataset.soraLbWaarde === naam ? 'true' : 'false');
        });
        const prijs = rij.querySelector('[data-sora-lb-prijs]');
        if (prijs) {
          const v = this.kandidaten(rij, naam)[0];
          if (v) maakPrijs(prijs, v, null, 'sora-lb__prijs');
          else prijs.innerHTML = st.prijsOrigineel;
        }
      }

      markeer(id) {
        this.querySelectorAll('.is-actief').forEach((el) => el.classList.remove('is-actief'));
        if (!id) return;
        this.querySelector(`[data-sora-lb-rij="${id}"]`)?.classList.add('is-actief');
        this.querySelector(`[data-sora-lb-doel="${id}"]`)?.classList.add('is-actief');
      }

      opAanwijzen = (event) => {
        const rij = event.target.closest('[data-sora-lb-rij]');
        if (event.type === 'mouseout') {
          if (rij && !rij.contains(event.relatedTarget)) this.markeer(null);
          return;
        }
        if (rij) this.markeer(rij.dataset.soraLbRij);
      };

      opKlik = (event) => {
        const stip = event.target.closest('[data-sora-lb-doel]');
        if (stip) {
          const id = stip.dataset.soraLbDoel;
          this.markeer(id);
          const rij = this.querySelector(`[data-sora-lb-rij="${id}"]`);
          if (rij) {
            const snel = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            rij.scrollIntoView({ behavior: snel ? 'auto' : 'smooth', block: 'nearest' });
            rij.querySelector('a, button')?.focus({ preventScroll: true });
          }
          return;
        }

        const waarde = event.target.closest('[data-sora-lb-waarde]');
        if (waarde) {
          const rij = waarde.closest('[data-sora-lb-rij]');
          const st = this.rijStatus(rij);
          const naam = waarde.dataset.soraLbWaarde;
          this.kiesRij(rij, st.keuze === naam ? null : naam);
          return;
        }

        const alles = event.target.closest('[data-sora-lb-alles]');
        if (alles) {
          if (alles.dataset.status !== 'bezig') this.alles(alles);
          return;
        }

        const knop = event.target.closest('[data-sora-lb-toevoegen]');
        if (knop && knop.dataset.status !== 'bezig') this.enkel(knop.closest('[data-sora-lb-rij]'), knop);
      };

      async enkel(rij, knop) {
        const st = this.rijStatus(rij);
        if (!st.data) return;
        const v = this.vasteVariant(rij);
        if (!v) {
          Popup.open(this, [rij], [], false, knop);
          return;
        }
        if (!v.beschikbaar) return;
        knop.dataset.status = 'bezig';
        const gelukt = await voegToe([v], knop);
        delete knop.dataset.status;
        this.toonKlaar(knop, gelukt);
      }

      async alles(knop) {
        const rijen = Array.from(this.querySelectorAll('[data-sora-lb-rij]')).filter(
          (rij) => rij.dataset.beschikbaar === 'true' && this.rijStatus(rij).data
        );
        if (!rijen.length) return;
        const ontbrekend = rijen.filter((rij) => !this.vasteVariant(rij));
        const vast = rijen.filter((rij) => this.vasteVariant(rij)).map((rij) => this.vasteVariant(rij));
        if (ontbrekend.length) {
          Popup.open(this, ontbrekend, vast, true, knop);
          return;
        }
        knop.dataset.status = 'bezig';
        const gelukt = await voegToe(vast, knop);
        delete knop.dataset.status;
        this.toonKlaar(knop, gelukt);
      }

      toonKlaar(knop, gelukt) {
        if (this.melding) this.melding.textContent = gelukt ? this.dataset.tekstToegevoegd : this.dataset.tekstFout;
        if (!gelukt || !knop) return;
        knop.dataset.status = 'klaar';
        clearTimeout(knop.klaarTimer);
        knop.klaarTimer = setTimeout(() => {
          if (knop.dataset.status === 'klaar') delete knop.dataset.status;
        }, 1800);
      }
    }

    customElements.define('sora-lookbook', SoraLookbook);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-product-configuration-table"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sora-product-configuration-table')) {
    class SoraProductConfigurationTable extends HTMLElement {
      connectedCallback() {
        this.currency = this.dataset.currency || 'EUR';
        this.locale = this.dataset.locale || 'nl';
        this.summaryText = '';

        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-sora-qty-input]')) {
            this.onQtyChange(event.target, true);
            return;
          }
          if (event.target.matches('[data-sora-option], [data-sora-select]')) this.update();
        });
        this.addEventListener('input', (event) => {
          if (event.target.matches('[data-sora-qty-input]')) this.onQtyChange(event.target, false);
        });
        this.addEventListener('click', (event) => this.onClick(event));

        const form = this.querySelector('.sora-pct__form');
        if (form) form.addEventListener('submit', () => this.prepareSubmit(form));

        this.querySelectorAll('[data-sora-money]').forEach((el) => {
          el.textContent = this.format(Number(el.dataset.soraMoney));
        });
        this.querySelectorAll('[data-sora-select] option').forEach((option) => {
          if (option.hasAttribute('data-sora-placeholder')) return;
          option.textContent =
            option.dataset.included === 'true'
              ? `${option.dataset.title} (${this.dataset.includedText})`
              : `${option.dataset.title} (+${this.format(Number(option.dataset.price))})`;
        });
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('close', () => this.unlockScroll());
        });
        this.update();

        if (this.dataset.posted === 'true' || this.querySelector('[data-sora-banner]')) {
          const banner = this.querySelector('[data-sora-banner]');
          if (banner) banner.scrollIntoView({ block: 'center' });
        }
      }

      format(cents) {
        const value = cents / 100;
        const whole = Number.isInteger(value);
        try {
          return new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency,
            minimumFractionDigits: whole ? 0 : 2,
            maximumFractionDigits: 2,
          }).format(value);
        } catch (e) {
          return value.toFixed(2);
        }
      }

      columnHeads() {
        return this.querySelectorAll('thead [data-sora-col]');
      }

      qtyInput(el) {
        const cell = el.closest('td');
        return cell ? cell.querySelector('[data-sora-qty-input]') : null;
      }

      clampQty(input, value) {
        const min = parseInt(input.min, 10) || 1;
        const max = parseInt(input.max, 10);
        let n = parseInt(value, 10);
        if (!Number.isFinite(n) || n < min) n = min;
        if (Number.isFinite(max) && n > max) n = max;
        return n;
      }

      /* Aantal in de editor (q) en gekozen aantal (n). null = rij zonder hoeveelheid. */
      qtyOf(el) {
        if (!el.hasAttribute('data-qty')) return null;
        const q = Math.max(1, parseInt(el.dataset.qty, 10) || 1);
        const input = this.qtyInput(el);
        return { q, n: input ? this.clampQty(input, input.value) : q };
      }

      minNote(q) {
        return (this.dataset.qtyMinNote || '').split('[aantal]').join(String(q));
      }

      /*
        Berekening per cel. Regels bij een hoeveelheid:
        - betaald (vinkje, of variant zonder inbegrepen variant): max(n, q) × prijs;
        - inbegrepen: tot q gratis, extra stuks (n - q) × productprijs;
        - duurdere variant dan de inbegrepen variant: q × meerprijs + extra stuks × volle prijs.
        Minder dan q gekozen: het bedrag van q blijft staan.
      */
      calc(el) {
        const qty = this.qtyOf(el);
        const sign = this.dataset.qtySign || '';
        const pre = (count) => (qty ? `${count}${sign} ` : '');
        const withNote = (label, below, q) => (below ? `${label} (${this.minNote(q)})` : label);

        if (el.matches('[data-sora-select]')) {
          const option = el.selectedOptions[0];
          if (!option || option.hasAttribute('data-sora-placeholder')) return { active: false, items: [], cost: 0, below: false };
          const label = `${el.dataset.label} (${option.dataset.title})`;
          const price = Number(option.dataset.price) || 0;
          const included = option.dataset.included === 'true';
          if (!qty) return { active: true, items: [{ label, price, included }], cost: included ? 0 : price, below: false };

          const { q, n } = qty;
          const full = Number(option.dataset.full) || price;
          if (el.dataset.ref !== 'true') {
            const cost = Math.max(n, q) * price;
            const below = n < q;
            return { active: true, items: [{ label: withNote(pre(n) + label, below, q), price: cost, included: false }], cost, below };
          }
          if (included) {
            const items = [{ label: pre(Math.min(n, q)) + label, price: 0, included: true }];
            const cost = n > q ? (n - q) * full : 0;
            if (cost > 0) items.push({ label: pre(n - q) + label, price: cost, included: false });
            return { active: true, items, cost, below: false };
          }
          const cost = q * price + Math.max(0, n - q) * full;
          const below = n < q;
          return { active: true, items: [{ label: withNote(pre(n) + label, below, q), price: cost, included: false }], cost, below };
        }

        if (el.matches('[data-sora-included]')) {
          const label = el.dataset.label;
          if (!qty) return { active: true, items: [{ label, price: 0, included: true }], cost: 0, below: false };
          const { q, n } = qty;
          const unit = Number(el.dataset.price) || 0;
          const items = [{ label: pre(Math.min(n, q)) + label, price: 0, included: true }];
          const cost = n > q ? (n - q) * unit : 0;
          if (cost > 0) items.push({ label: pre(n - q) + label, price: cost, included: false });
          return { active: true, items, cost, below: false };
        }

        const unit = Number(el.dataset.price) || 0;
        const { q, n } = qty || { q: 1, n: 1 };
        const cost = Math.max(n, q) * unit;
        const below = Boolean(qty) && n < q;
        return {
          active: el.checked,
          items: el.checked ? [{ label: withNote(pre(n) + el.dataset.label, below, q), price: cost, included: false }] : [],
          cost,
          below,
        };
      }

      selectedFor(colId) {
        return Array.from(this.querySelectorAll('[data-sora-option], [data-sora-select], [data-sora-included]'))
          .filter((el) => el.dataset.col === colId)
          .flatMap((el) => {
            const result = this.calc(el);
            return result.active ? result.items : [];
          });
      }

      onQtyChange(input, commit) {
        if (commit) input.value = this.clampQty(input, input.value);
        const cell = input.closest('td');
        const checkbox = cell ? cell.querySelector('[data-sora-option]') : null;
        if (checkbox) checkbox.checked = true;
        this.update();
      }

      updateQuantities() {
        this.querySelectorAll('[data-sora-option][data-qty], [data-sora-select][data-qty], [data-sora-included][data-qty]').forEach((el) => {
          const cell = el.closest('td');
          if (!cell) return;
          const result = this.calc(el);
          const costEl = cell.querySelector('[data-sora-cost]');
          if (costEl) costEl.textContent = this.format(result.cost);
          const line = cell.querySelector('[data-sora-cost-line]');
          if (line) line.hidden = !result.active || result.cost <= 0;
          const note = cell.querySelector('[data-sora-qty-note]');
          if (note) {
            note.textContent = this.minNote(Math.max(1, parseInt(el.dataset.qty, 10) || 1));
            note.hidden = !(result.below && (result.active || el.matches('[data-sora-option]')));
          }
          const input = cell.querySelector('[data-sora-qty-input]');
          if (input) {
            const n = this.clampQty(input, input.value);
            const max = parseInt(input.max, 10);
            const less = cell.querySelector('[data-sora-qty-step="-1"]');
            const more = cell.querySelector('[data-sora-qty-step="1"]');
            if (less) less.setAttribute('aria-disabled', String(n <= (parseInt(input.min, 10) || 1)));
            if (more) more.setAttribute('aria-disabled', String(Number.isFinite(max) && n >= max));
          }
        });
      }

      totalFor(head) {
        const base = Number(head.dataset.base) || 0;
        const items = this.selectedFor(head.dataset.soraCol);
        const extras = items.filter((item) => !item.included);
        const included = items.filter((item) => item.included);
        const optionsTotal = extras.reduce((sum, item) => sum + item.price, 0);
        return { base, extras, included, total: base + optionsTotal };
      }

      update() {
        this.updateQuantities();
        const short = {
          base: this.dataset.labelBaseShort || '',
          options: this.dataset.labelOptionsShort || '',
        };
        this.columnHeads().forEach((head) => {
          const { base, extras, total } = this.totalFor(head);
          head.querySelector('[data-sora-total]').textContent = this.format(total);
          const sub = head.querySelector('[data-sora-sub]');
          sub.textContent = extras.length
            ? `${short.base} ${this.format(base)} + ${extras.length} ${short.options}`
            : `${short.base} ${this.format(base)}`;
        });
        const reset = this.querySelector('[data-sora-reset]');
        if (reset) {
          const dirty =
            Array.from(this.querySelectorAll('[data-sora-option]')).some((input) => input.checked) ||
            Array.from(this.querySelectorAll('[data-sora-select]')).some(
              (select) => !select.selectedOptions[0].defaultSelected
            ) ||
            Array.from(this.querySelectorAll('[data-sora-qty-input]')).some(
              (input) => this.clampQty(input, input.value) !== this.clampQty(input, input.defaultValue)
            );
          reset.hidden = !dirty;
        }
      }

      disconnectedCallback() {
        document.documentElement.classList.remove('sora-pct-lock');
      }

      lockScroll() {
        document.documentElement.classList.add('sora-pct-lock');
      }

      unlockScroll() {
        if (!document.querySelector('dialog.sora-pct__dialog[open]')) {
          document.documentElement.classList.remove('sora-pct-lock');
        }
      }

      openDialog(dialog) {
        if (!dialog) return;
        this.lockScroll();
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }

      closeDialog(dialog) {
        if (!dialog) return;
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        this.unlockScroll();
      }

      onClick(event) {
        const target = event.target;

        if (target.tagName === 'DIALOG') {
          this.closeDialog(target);
          return;
        }

        const opener = target.closest('[data-sora-open]');
        if (opener) {
          this.openDialog(document.getElementById(opener.dataset.soraOpen));
          return;
        }

        if (target.closest('[data-sora-close]')) {
          this.closeDialog(target.closest('dialog'));
          return;
        }

        const step = target.closest('[data-sora-qty-step]');
        if (step) {
          const input = step.closest('[data-sora-qty]').querySelector('[data-sora-qty-input]');
          if (!input || step.getAttribute('aria-disabled') === 'true') return;
          input.value = this.clampQty(input, this.clampQty(input, input.value) + Number(step.dataset.soraQtyStep));
          this.onQtyChange(input, true);
          return;
        }

        if (target.closest('[data-sora-reset]')) {
          this.querySelectorAll('[data-sora-option]').forEach((input) => (input.checked = false));
          this.querySelectorAll('[data-sora-qty-input]').forEach((input) => (input.value = input.defaultValue));
          this.querySelectorAll('[data-sora-select]').forEach((select) => {
            const index = Array.from(select.options).findIndex((option) => option.defaultSelected);
            select.selectedIndex = index < 0 ? 0 : index;
          });
          this.update();
          return;
        }

        const choose = target.closest('[data-sora-choose]');
        if (choose) this.choosePackage(choose.dataset.soraChoose);
      }

      choosePackage(colId) {
        const head = Array.from(this.columnHeads()).find((el) => el.dataset.soraCol === colId);
        if (!head) return;

        const { base, extras, included: includedChoices, total } = this.totalFor(head);
        const included = includedChoices.map((item) => item.label);
        const extraItems = extras.map((item) => ({ label: item.label, price: item.price }));

        const L = {
          pkg: this.dataset.labelPackage,
          base: this.dataset.labelBase,
          included: this.dataset.labelIncluded,
          extras: this.dataset.labelExtras,
          total: this.dataset.labelTotal,
        };

        const lines = [`${L.pkg}: ${head.dataset.name}`, `${L.base}: ${this.format(base)}`];
        if (included.length) lines.push(`${L.included}: ${included.join(', ')}`);
        if (extraItems.length) {
          lines.push(`${L.extras}:`);
          extraItems.forEach((item) => lines.push(`- ${item.label} (+${this.format(item.price)})`));
        }
        lines.push(`${L.total}: ${this.format(total)}`);
        this.summaryText = lines.join('\n');

        this.renderSummary({ L, head, base, included, extraItems, total });
        const spec = this.querySelector('[data-sora-spec]');
        if (spec) spec.open = false;
        this.openDialog(this.querySelector('.sora-pct__dialog--contact'));
      }

      renderSummary({ L, head, base, included, extraItems, total }) {
        const box = this.querySelector('[data-sora-summary]');
        const topPrice = this.querySelector('[data-sora-form-total]');
        if (topPrice) topPrice.textContent = this.format(total);
        if (!box) return;
        box.textContent = '';

        const addLine = (text, strong) => {
          const p = document.createElement('p');
          if (strong) {
            const b = document.createElement('strong');
            b.textContent = strong;
            p.append(b, ' ');
          }
          p.append(text);
          box.appendChild(p);
        };
        const addList = (heading, items) => {
          const p = document.createElement('p');
          const b = document.createElement('strong');
          b.textContent = heading;
          p.appendChild(b);
          box.appendChild(p);
          const ul = document.createElement('ul');
          items.forEach((text) => {
            const li = document.createElement('li');
            li.textContent = text;
            ul.appendChild(li);
          });
          box.appendChild(ul);
        };

        addLine(head.dataset.name, `${L.pkg}:`);
        addLine(this.format(base), `${L.base}:`);
        if (included.length) addList(`${L.included}:`, included);
        if (extraItems.length) {
          addList(`${L.extras}:`, extraItems.map((i) => `${i.label} (+${this.format(i.price)})`));
        }
      }

      prepareSubmit(form) {
        const body = form.querySelector('[data-sora-body]');
        const message = form.querySelector('[data-sora-message]');
        if (!body) return;
        const text = message ? message.value.trim() : '';
        const extra = form.querySelector('[data-sora-extra-select]');
        const extraLine = extra && extra.value ? `\n${extra.dataset.label}: ${extra.value}` : '';
        const selection = this.summaryText + extraLine;
        body.value = text ? `${text}\n\n${selection}` : selection;
      }
    }
    customElements.define('sora-product-configuration-table', SoraProductConfigurationTable);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-productvariantkaart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sora-productvariantkaart')) {
    class SoraProductvariantkaart extends HTMLElement {
      connectedCallback() {
        if (this.soraKlaar) return;
        this.soraKlaar = true;
        this.samenvatting = '';

        this.addEventListener('change', (event) => {
          if (event.target.matches('.sora-pvk__radio')) this.markeer();
        });
        this.addEventListener('click', (event) => this.onClick(event));

        const form = this.querySelector('.sora-pvk__form');
        if (form) form.addEventListener('submit', () => this.voorbereiden(form));
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('close', () => this.ontgrendel());
        });
        this.markeer();

        const banner = this.querySelector('[data-sora-pvk-banner]');
        if (banner) banner.scrollIntoView({ block: 'center' });
      }

      disconnectedCallback() {
        document.documentElement.classList.remove('sora-pvk-lock');
      }

      gekozen() {
        return this.querySelector('.sora-pvk__radio:checked');
      }

      markeer() {
        this.querySelectorAll('.sora-pvk__kaart').forEach((kaart) => {
          const radio = kaart.querySelector('.sora-pvk__radio');
          kaart.classList.toggle('is-gekozen', Boolean(radio && radio.checked));
        });
        const hint = this.querySelector('[data-sora-pvk-hint]');
        if (hint && this.gekozen()) hint.hidden = true;
      }

      vergrendel() {
        document.documentElement.classList.add('sora-pvk-lock');
      }

      ontgrendel() {
        if (!document.querySelector('dialog.sora-pvk__dialog[open]')) {
          document.documentElement.classList.remove('sora-pvk-lock');
        }
      }

      open(dialog) {
        if (!dialog) return;
        this.vergrendel();
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }

      sluit(dialog) {
        if (!dialog) return;
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        this.ontgrendel();
      }

      onClick(event) {
        const target = event.target;
        if (target.tagName === 'DIALOG') {
          this.sluit(target);
          return;
        }
        if (target.closest('[data-sora-pvk-sluit]')) {
          this.sluit(target.closest('dialog'));
          return;
        }
        if (target.closest('[data-sora-pvk-kies]')) this.kies();
      }

      kies() {
        const radio = this.gekozen();
        if (!radio) {
          const hint = this.querySelector('[data-sora-pvk-hint]');
          if (hint) hint.hidden = false;
          const eerste = this.querySelector('.sora-pvk__radio:not(:disabled)');
          if (eerste) eerste.focus();
          return;
        }
        const naam = radio.dataset.naam || '';
        const prijs = radio.dataset.prijs || '';
        const naamVeld = this.querySelector('[data-sora-pvk-form-naam]');
        const prijsVeld = this.querySelector('[data-sora-pvk-form-prijs]');
        if (naamVeld) naamVeld.textContent = naam;
        if (prijsVeld) prijsVeld.textContent = prijs;

        const regels = [];
        if (this.dataset.product) regels.push(`${this.dataset.labelProduct}: ${this.dataset.product}`);
        regels.push(`${this.dataset.labelKeuze}: ${naam}`);
        regels.push(`${this.dataset.labelPrijs}: ${prijs}`);
        this.samenvatting = regels.join('\n');

        this.open(this.querySelector('.sora-pvk__dialog'));
      }

      voorbereiden(form) {
        const body = form.querySelector('[data-sora-pvk-body]');
        if (!body) return;
        const bericht = form.querySelector('[data-sora-pvk-bericht]');
        const tekst = bericht ? bericht.value.trim() : '';
        const extra = form.querySelector('[data-sora-pvk-extra]');
        const extraRegel = extra && extra.value ? `\n${extra.dataset.label}: ${extra.value}` : '';
        const selectie = this.samenvatting + extraRegel;
        body.value = tekst ? `${tekst}\n\n${selectie}` : selectie;
      }
    }
    customElements.define('sora-productvariantkaart', SoraProductvariantkaart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-seo-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sora-seo-tekst')) return;

    class SoraSeoTekst extends HTMLElement {
      connectedCallback() {
        this.tekst = this.querySelector('[data-sora-seo-tekst]');
        this.knop = this.querySelector('[data-sora-seo-knop]');
        this.label = this.querySelector('[data-sora-seo-label]');
        if (!this.tekst || !this.knop) return;
        this.knop.addEventListener('click', this.wissel);
        this.meet();
        if ('ResizeObserver' in window) {
          this.waarnemer = new ResizeObserver(() => this.meet());
          this.waarnemer.observe(this.tekst);
        }
      }

      disconnectedCallback() {
        this.knop?.removeEventListener('click', this.wissel);
        this.waarnemer?.disconnect();
      }

      meet() {
        if (this.classList.contains('is-open')) return;
        const grens = parseFloat(getComputedStyle(this).getPropertyValue('--sora-seo-ingeklapt')) || 0;
        const te_lang = this.tekst.scrollHeight > grens + 8;
        this.classList.toggle('is-inklapbaar', te_lang);
        this.knop.hidden = !te_lang;
      }

      wissel = () => {
        const open = !this.classList.contains('is-open');
        this.classList.toggle('is-open', open);
        this.knop.setAttribute('aria-expanded', String(open));
        if (this.label) this.label.textContent = open ? this.dataset.minder : this.dataset.meer;
      };
    }

    customElements.define('sora-seo-tekst', SoraSeoTekst);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sora-ticker"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bijwerken = (el) => {
      const helften = el.querySelectorAll('[data-sora-ticker-helft]');
      const eerste = helften[0];
      if (!eerste) return;
      const groep = eerste.querySelector('[data-sora-ticker-groep]');
      if (!groep) return;

      el.querySelectorAll('[data-sora-kopie]').forEach((n) => n.remove());
      const mobiel = window.matchMedia('(max-width: 749px)').matches;
      if ((mobiel ? el.dataset.stilMobiel : el.dataset.stilDesktop) === 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let teller = 0;
      while (eerste.offsetWidth > 0 && eerste.offsetWidth < el.clientWidth && teller < 30) {
        helften.forEach((helft) => {
          const kopie = groep.cloneNode(true);
          kopie.setAttribute('aria-hidden', 'true');
          kopie.setAttribute('inert', '');
          kopie.setAttribute('data-sora-kopie', '');
          helft.appendChild(kopie);
        });
        teller += 1;
      }

      const snelheid = Number(el.dataset.snelheid) || 60;
      const duur = Math.max(5, eerste.offsetWidth / snelheid);
      el.style.setProperty('--sora-ticker-duur', `${duur}s`);
    };

    const meetHoogte = (el) => {
      if (el.dataset.vast !== 'true') return;
      document.documentElement.style.setProperty('--sora-ticker-vast-hoogte', `${el.offsetHeight}px`);
    };

    const start = (root) => {
      root.querySelectorAll('[data-sora-ticker]').forEach((el) => {
        bijwerken(el);
        meetHoogte(el);
        if (el.soraTickerWaarnemer || !('ResizeObserver' in window)) return;
        let breedte = el.clientWidth;
        el.soraTickerWaarnemer = new ResizeObserver(() => {
          meetHoogte(el);
          if (el.clientWidth === breedte) return;
          breedte = el.clientWidth;
          bijwerken(el);
        });
        el.soraTickerWaarnemer.observe(el);
      });
    };

    const opstarten = () => start(document);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', opstarten);
    } else {
      opstarten();
    }
    document.addEventListener('shopify:section:load', (event) => start(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
